window.locations = [
  {
    "original_Store Name": "Nola Boards",
    "original_City": "New Orleans",
    "original_State": "LA",
    "lat": 29.9559145,
    "lon": -90.0730259
  },
  {
    "original_Store Name": "The Great Alaskan Bowl Company",
    "original_City": "Fairbanks",
    "original_State": "AK",
    "lat": 64.837845,
    "lon": -147.716675
  },
  {
    "original_Store Name": "The Museum Store",
    "original_City": "Washington",
    "original_State": "DC",
    "lat": 38.8950368,
    "lon": -77.0365427
  },
  {
    "original_Store Name": "East Fork",
    "original_City": "Asheville",
    "original_State": "NC",
    "lat": 35.595363,
    "lon": -82.5508407
  },
  {
    "original_Store Name": "A.J. Soseby",
    "original_City": "Columbus",
    "original_State": "OH",
    "lat": 39.9622601,
    "lon": -83.0007065
  },
  {
    "original_Store Name": "LocalWe",
    "original_City": "Pittstown",
    "original_State": "NJ",
    "lat": 40.5821362,
    "lon": -74.9589826
  },
  {
    "original_Store Name": "Andrew Jackson’s Hermitage",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Golden Fig Fine Foods",
    "original_City": "Saint Paul",
    "original_State": "MN",
    "lat": 44.9497487,
    "lon": -93.0931028
  },
  {
    "original_Store Name": "Farmstead Market",
    "original_City": "Columbia",
    "original_State": "TN",
    "lat": 35.6148165,
    "lon": -87.0338464
  },
  {
    "original_Store Name": "Gardenside Shop LLC",
    "original_City": "Marietta",
    "original_State": "GA",
    "lat": 33.9528472,
    "lon": -84.5496148
  },
  {
    "original_Store Name": "Earthbound Farm Stand",
    "original_City": "carmel",
    "original_State": "CA",
    "lat": 36.5552656,
    "lon": -121.923278
  },
  {
    "original_Store Name": "Batterby House",
    "original_City": "Hudson",
    "original_State": "NY",
    "lat": 42.2528649,
    "lon": -73.790959
  },
  {
    "original_Store Name": "Locke Store",
    "original_City": "Millwood",
    "original_State": "VA",
    "lat": 39.069551,
    "lon": -78.0377754
  },
  {
    "original_Store Name": "OHSAY USA",
    "original_City": "Austin",
    "original_State": "TX",
    "lat": 30.2711286,
    "lon": -97.7436995
  },
  {
    "original_Store Name": "Grappe Farms",
    "original_City": "Lubbock",
    "original_State": "TX",
    "lat": 33.5855677,
    "lon": -101.8470215
  },
  {
    "original_Store Name": "The Artist's Kitchen Shop",
    "original_City": "Sedona",
    "original_State": "AZ",
    "lat": 34.8688613,
    "lon": -111.7614394
  },
  {
    "original_Store Name": "Galena Spoon Co.",
    "original_City": "Galena",
    "original_State": "IL",
    "lat": 42.4157304,
    "lon": -90.4294726
  },
  {
    "original_Store Name": "Mentone Market",
    "original_City": "Mentone",
    "original_State": "AL",
    "lat": 34.5795282,
    "lon": -85.5905204
  },
  {
    "original_Store Name": "Good Kinsmen, LlC",
    "original_City": "Chattanooga",
    "original_State": "TN",
    "lat": 35.0457219,
    "lon": -85.3094883
  },
  {
    "original_Store Name": "Salt Creek Farmhouse",
    "original_City": "Ashland",
    "original_State": "NE",
    "lat": 41.0391711,
    "lon": -96.3683917
  },
  {
    "original_Store Name": "Stix & Stones Gallery",
    "original_City": "Calistoga",
    "original_State": "CA",
    "lat": 38.5787966,
    "lon": -122.579705
  },
  {
    "original_Store Name": "The Standard McKinney",
    "original_City": "McKinney",
    "original_State": "TX",
    "lat": 33.1976496,
    "lon": -96.6154471
  },
  {
    "original_Store Name": "Omni Hotels & Resorts",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Hill Country Dwellings",
    "original_City": "Hico",
    "original_State": "TX",
    "lat": 31.9814482,
    "lon": -98.0308515
  },
  {
    "original_Store Name": "J. Danforth Mercantile LLC",
    "original_City": "Maryville",
    "original_State": "TN",
    "lat": 35.7564719,
    "lon": -83.9704593
  },
  {
    "original_Store Name": "Base Camp",
    "original_City": "Calistoga",
    "original_State": "CA",
    "lat": 38.5787966,
    "lon": -122.579705
  },
  {
    "original_Store Name": "Eastport General Store",
    "original_City": "Eastport",
    "original_State": "NY",
    "lat": 40.8259322,
    "lon": -72.7317659
  },
  {
    "original_Store Name": "Depanneur",
    "original_City": "Brooklyn",
    "original_State": "NY",
    "lat": 40.6526006,
    "lon": -73.9497211
  },
  {
    "original_Store Name": "PERCH Home and Hospitality",
    "original_City": "Gallatin",
    "original_State": "TN",
    "lat": 36.3883031,
    "lon": -86.4475898
  },
  {
    "original_Store Name": "Asher + Rye",
    "original_City": "Savannah",
    "original_State": "GA",
    "lat": 32.0790074,
    "lon": -81.0921335
  },
  {
    "original_Store Name": "Lineage",
    "original_City": "Harrisonburg",
    "original_State": "VA",
    "lat": 38.4493315,
    "lon": -78.8688833
  },
  {
    "original_Store Name": "Lauren Kroesser",
    "original_City": "Hamilton",
    "original_State": "MA",
    "lat": 42.6362052,
    "lon": -70.8431049
  },
  {
    "original_Store Name": "Flamingo Rodeo",
    "original_City": "Spring",
    "original_State": "TX",
    "lat": 30.0795707,
    "lon": -95.4187924
  },
  {
    "original_Store Name": "Atticus Market",
    "original_City": "New Haven",
    "original_State": "CT",
    "lat": 41.3082138,
    "lon": -72.9250518
  },
  {
    "original_Store Name": "Iowa Artisans Gallery",
    "original_City": "Iowa City",
    "original_State": "IA",
    "lat": 41.6612561,
    "lon": -91.5299106
  },
  {
    "original_Store Name": "Root House",
    "original_City": "Pagosa Springs",
    "original_State": "CO",
    "lat": 37.2695661,
    "lon": -107.010816
  },
  {
    "original_Store Name": "Farmhouse Wares",
    "original_City": "South Deerfield",
    "original_State": "MA",
    "lat": 42.4773046,
    "lon": -72.6079039
  },
  {
    "original_Store Name": "Timberline",
    "original_City": "Lake City ",
    "original_State": "CO",
    "lat": 38.03047,
    "lon": -107.316985
  },
  {
    "original_Store Name": "Prairie Kitchen Store LLC",
    "original_City": "Iowa City",
    "original_State": "IA",
    "lat": 41.6612561,
    "lon": -91.5299106
  },
  {
    "original_Store Name": "Lulu Cadieux",
    "original_City": "Saugatuck",
    "original_State": "MI",
    "lat": 42.6549244,
    "lon": -86.2040552
  },
  {
    "original_Store Name": "The Copper Cellar Marketplace",
    "original_City": "Knoxville",
    "original_State": "TN",
    "lat": 35.9603948,
    "lon": -83.9210261
  },
  {
    "original_Store Name": "Ladles & Linens Ltd.",
    "original_City": "Richmond",
    "original_State": "VA",
    "lat": 37.5385087,
    "lon": -77.43428
  },
  {
    "original_Store Name": "Be Just - Domestic Tools, Home Supplies, Botanicals",
    "original_City": "Charlottesville",
    "original_State": "VA",
    "lat": 38.029306,
    "lon": -78.4766781
  },
  {
    "original_Store Name": "Peyton's",
    "original_City": "CATSKILL",
    "original_State": "NY",
    "lat": 42.2173102,
    "lon": -73.8645734
  },
  {
    "original_Store Name": "The Lemon Fair",
    "original_City": "Sewanee",
    "original_State": "TN",
    "lat": 35.2031373,
    "lon": -85.9210899
  },
  {
    "original_Store Name": "Wood Station Co-Op",
    "original_City": "Oconomowoc",
    "original_State": "WI",
    "lat": 43.1116731,
    "lon": -88.4992659
  },
  {
    "original_Store Name": "SCOUT of Marion, 725 11th st, Marion, IA 52302",
    "original_City": "Marion",
    "original_State": "IA",
    "lat": 42.0329753,
    "lon": -91.5987335
  },
  {
    "original_Store Name": "Bench and Board",
    "original_City": "Edmonds",
    "original_State": "WA",
    "lat": 47.8105738,
    "lon": -122.3774952
  },
  {
    "original_Store Name": "15 Steps",
    "original_City": "Ithaca",
    "original_State": "NY",
    "lat": 42.4374175,
    "lon": -76.5483723513926
  },
  {
    "original_Store Name": "Confituras Little Kitchen",
    "original_City": "Austin",
    "original_State": "TX",
    "lat": 30.2711286,
    "lon": -97.7436995
  },
  {
    "original_Store Name": "Los Poblanos Farm Shop",
    "original_City": "Los Ranchos de Albuquerque",
    "original_State": "NM",
    "lat": 35.1619885,
    "lon": -106.6428038
  },
  {
    "original_Store Name": "Salt & Grove",
    "original_City": "Newburyport",
    "original_State": "MA",
    "lat": 42.8116592,
    "lon": -70.8719271
  },
  {
    "original_Store Name": "Twine Graphics - Retail Shop",
    "original_City": "Franklin",
    "original_State": "TN",
    "lat": 35.925206,
    "lon": -86.8689419
  },
  {
    "original_Store Name": "Material Wit",
    "original_City": "Eastsound",
    "original_State": "WA",
    "lat": 48.696771,
    "lon": -122.9054625
  },
  {
    "original_Store Name": "One Mercantile & Sett",
    "original_City": "Great Barrington",
    "original_State": "MA",
    "lat": 42.1939364,
    "lon": -73.362773
  },
  {
    "original_Store Name": "Bread Furst",
    "original_City": "Washington",
    "original_State": "DC",
    "lat": 38.8950368,
    "lon": -77.0365427
  },
  {
    "original_Store Name": "Woodland Mod",
    "original_City": "Seattle",
    "original_State": "WA",
    "lat": 47.6038321,
    "lon": -122.330062
  },
  {
    "original_Store Name": "Relish Decor",
    "original_City": "Frederick",
    "original_State": "MD",
    "lat": 39.415779,
    "lon": -77.4127562
  },
  {
    "original_Store Name": "Deep South Mercantile",
    "original_City": "Arab",
    "original_State": "AL",
    "lat": 34.3181497,
    "lon": -86.4958219
  },
  {
    "original_Store Name": "The Find",
    "original_City": "Wayne Township",
    "original_State": "IN",
    "lat": 32.502337,
    "lon": -92.1243209322067
  },
  {
    "original_Store Name": "Driftwood & Linen",
    "original_City": "Solana Beach",
    "original_State": "CA",
    "lat": 32.9919141,
    "lon": -117.2678124
  },
  {
    "original_Store Name": "The Rabbit Hole",
    "original_City": "Asheville",
    "original_State": "NC",
    "lat": 35.595363,
    "lon": -82.5508407
  },
  {
    "original_Store Name": "Prism & Maker's Loft",
    "original_City": "Oakland",
    "original_State": "CA",
    "lat": 37.8044557,
    "lon": -122.271356
  },
  {
    "original_Store Name": "House on Scott",
    "original_City": "Parkville",
    "original_State": "MO",
    "lat": 39.1896268,
    "lon": -94.6826891
  },
  {
    "original_Store Name": "Berea Top Drawer Gallery LLC",
    "original_City": "Berea",
    "original_State": "KY",
    "lat": 37.568694,
    "lon": -84.2963224
  },
  {
    "original_Store Name": "Made in TN",
    "original_City": "Franklin",
    "original_State": "TN",
    "lat": 35.925206,
    "lon": -86.8689419
  },
  {
    "original_Store Name": "20|EAST",
    "original_City": "Cazenovia",
    "original_State": "NY",
    "lat": 42.9300668,
    "lon": -75.8526969
  },
  {
    "original_Store Name": "The Farmhouse Project",
    "original_City": "Hortonville",
    "original_State": "NY",
    "lat": 41.764255,
    "lon": -75.0301665
  },
  {
    "original_Store Name": "Harvest Moon Bakery",
    "original_City": "Fort Smith",
    "original_State": "AR",
    "lat": 35.3880338,
    "lon": -94.4265011
  },
  {
    "original_Store Name": "Chehalem Flats Farm Market",
    "original_City": "Newberg",
    "original_State": "OR",
    "lat": 45.300347,
    "lon": -122.972751
  },
  {
    "original_Store Name": "California 89",
    "original_City": "Truckee",
    "original_State": "CA",
    "lat": 39.3279454,
    "lon": -120.1835765
  },
  {
    "original_Store Name": "Sassafras on Sutton",
    "original_City": "Black Mountain",
    "original_State": "NC",
    "lat": 35.6176544,
    "lon": -82.3205791
  },
  {
    "original_Store Name": "Seascape Foods",
    "original_City": "Aptos",
    "original_State": "CA",
    "lat": 36.9817,
    "lon": -121.889
  },
  {
    "original_Store Name": "The Artisan's Bench",
    "original_City": "Brighton",
    "original_State": "MI",
    "lat": 42.5316918,
    "lon": -83.7846458
  },
  {
    "original_Store Name": "Wild Carrot Herbals",
    "original_City": "Enterprise",
    "original_State": "OR",
    "lat": 45.4258114,
    "lon": -117.278012
  },
  {
    "original_Store Name": "The Grey Barn and Farm",
    "original_City": "Chilmark",
    "original_State": "MA",
    "lat": 41.343056,
    "lon": -70.7440232
  },
  {
    "original_Store Name": "Made in TN",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Black Oak Home & Haven Co.",
    "original_City": "Dorr Township",
    "original_State": "IL",
    "lat": 42.261461,
    "lon": -88.442908
  },
  {
    "original_Store Name": "The Hidden Acorn",
    "original_City": "Woodbury",
    "original_State": "CT",
    "lat": 41.5445404,
    "lon": -73.2090025
  },
  {
    "original_Store Name": "The Happy Cook",
    "original_City": "Charlottesville",
    "original_State": "VA",
    "lat": 38.029306,
    "lon": -78.4766781
  },
  {
    "original_Store Name": "The Swag",
    "original_City": "Jonathan Creek",
    "original_State": "NC",
    "lat": 35.566852,
    "lon": -83.019344
  },
  {
    "original_Store Name": "The Grateful Gourmet Co.",
    "original_City": "Galena",
    "original_State": "IL",
    "lat": 42.4157304,
    "lon": -90.4294726
  },
  {
    "original_Store Name": "The Social LLC",
    "original_City": "Mt Olive",
    "original_State": "AL",
    "lat": 33.6709369,
    "lon": -86.8561047
  },
  {
    "original_Store Name": "The Nest",
    "original_City": "Ojai",
    "original_State": "CA",
    "lat": 34.4480495,
    "lon": -119.242889
  },
  {
    "original_Store Name": "Spaced Out Studio",
    "original_City": "Chicago",
    "original_State": "IL",
    "lat": 41.8755616,
    "lon": -87.6244212
  },
  {
    "original_Store Name": "The Farm Stand at Naples Canning Co.",
    "original_City": "Naples",
    "original_State": "FL",
    "lat": 26.1421976,
    "lon": -81.7942944
  },
  {
    "original_Store Name": "Mary’s Delight Decor & More",
    "original_City": "Parsons",
    "original_State": "TN",
    "lat": 35.649791,
    "lon": -88.1267025
  },
  {
    "original_Store Name": "Sisters Boutique & Gifts",
    "original_City": "Nags Head",
    "original_State": "NC",
    "lat": 35.9573923,
    "lon": -75.624062
  },
  {
    "original_Store Name": "Steep Mountain Tea House",
    "original_City": "Bozeman",
    "original_State": "MT",
    "lat": 45.6794293,
    "lon": -111.044047
  },
  {
    "original_Store Name": "Appalachian Fireside Gallery",
    "original_City": "Berea",
    "original_State": "KY",
    "lat": 37.568694,
    "lon": -84.2963224
  },
  {
    "original_Store Name": "Mockingbird Hospitality Co.",
    "original_City": "Van Alstyne",
    "original_State": "TX",
    "lat": 33.4220266,
    "lon": -96.5764834
  },
  {
    "original_Store Name": "Marigold & Grey",
    "original_City": "Rockville",
    "original_State": "MD",
    "lat": 39.0817985,
    "lon": -77.1516844
  },
  {
    "original_Store Name": "Slabtown Mercantile",
    "original_City": "Cambria",
    "original_State": "CA",
    "lat": 35.5641425,
    "lon": -121.081106
  },
  {
    "original_Store Name": "Sugarbeet's Pantry",
    "original_City": "lagrange",
    "original_State": "KY",
    "lat": 37.05789795,
    "lon": -85.0879479493916
  },
  {
    "original_Store Name": "Ellison",
    "original_City": "Boone",
    "original_State": "NC",
    "lat": 36.2187873,
    "lon": -81.684004
  },
  {
    "original_Store Name": "Ftw supply shop",
    "original_City": "Fort Collins",
    "original_State": "CO",
    "lat": 40.5871782,
    "lon": -105.0770113
  },
  {
    "original_Store Name": "Groundswell Table + Provisions",
    "original_City": "Tiverton",
    "original_State": "RI",
    "lat": 41.6257406,
    "lon": -71.166333
  },
  {
    "original_Store Name": "Bergamot + Amor",
    "original_City": "Williamstown",
    "original_State": "VT",
    "lat": 44.1224482,
    "lon": -72.5413894
  },
  {
    "original_Store Name": "Hermitage Retail, LLC",
    "original_City": "Goshen",
    "original_State": "KY",
    "lat": 38.4018644,
    "lon": -85.5810245
  },
  {
    "original_Store Name": "Brasswood Bar + Bakery",
    "original_City": "St. Helena",
    "original_State": "CA",
    "lat": 38.5052288,
    "lon": -122.470042
  },
  {
    "original_Store Name": "The Domesticated Engineer",
    "original_City": "Decatur",
    "original_State": "GA",
    "lat": 33.7737582,
    "lon": -84.296069
  },
  {
    "original_Store Name": "The Ecology Center",
    "original_City": "San Juan Capistrano",
    "original_State": "CA",
    "lat": 33.5016932,
    "lon": -117.6625509
  },
  {
    "original_Store Name": "Part & Parcel",
    "original_City": "Biddeford",
    "original_State": "ME",
    "lat": 43.4925843,
    "lon": -70.4533844
  },
  {
    "original_Store Name": "Sylvester & Co.",
    "original_City": "East Hampton",
    "original_State": "NY",
    "lat": 40.9633868,
    "lon": -72.1847598
  },
  {
    "original_Store Name": "NASH Boards",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Farmhaus",
    "original_City": "Fredericksburg ",
    "original_State": "TX",
    "lat": 30.2752011,
    "lon": -98.8719843
  },
  {
    "original_Store Name": "Fleur de Leigh",
    "original_City": "Huntsville",
    "original_State": "AL",
    "lat": 34.729847,
    "lon": -86.5859011
  },
  {
    "original_Store Name": "Theology of Home Mercantile",
    "original_City": "Fredericksburg",
    "original_State": "VA",
    "lat": 38.3031837,
    "lon": -77.4605399
  },
  {
    "original_Store Name": "Once A Tree",
    "original_City": "Camden",
    "original_State": "ME",
    "lat": 44.210265,
    "lon": -69.065552
  },
  {
    "original_Store Name": "Makers Collective Pop Up Shop",
    "original_City": "Greenville",
    "original_State": "SC",
    "lat": 34.851354,
    "lon": -82.3984882
  },
  {
    "original_Store Name": "The Market Chef",
    "original_City": "Friday Harbor",
    "original_State": "WA",
    "lat": 48.5342662,
    "lon": -123.017124
  },
  {
    "original_Store Name": "B&B Cabinetry+Home Design Co.",
    "original_City": "Hamilton",
    "original_State": "MT",
    "lat": 46.2472045,
    "lon": -114.1555462
  },
  {
    "original_Store Name": "Alabama Cork and Grain LLC dba Southern General",
    "original_City": "Arab",
    "original_State": "AL",
    "lat": 34.3181497,
    "lon": -86.4958219
  },
  {
    "original_Store Name": "Gift Goose",
    "original_City": "Valdosta",
    "original_State": "GA",
    "lat": 30.8327022,
    "lon": -83.2784851
  },
  {
    "original_Store Name": "BCOutdoors and BC MRKT",
    "original_City": "Charleston",
    "original_State": "NC",
    "lat": 36.1201561,
    "lon": -77.3755239
  },
  {
    "original_Store Name": "Jane The Bakery",
    "original_City": "San Francisco",
    "original_State": "CA",
    "lat": 37.7792588,
    "lon": -122.4193286
  },
  {
    "original_Store Name": "Southern Crafted",
    "original_City": "Savannah",
    "original_State": "GA",
    "lat": 32.0790074,
    "lon": -81.0921335
  },
  {
    "original_Store Name": "Beautiful Mess Home",
    "original_City": "Agoura Hills",
    "original_State": "CA",
    "lat": 34.1481692,
    "lon": -118.7655456
  },
  {
    "original_Store Name": "Grateful Table Cafe & Provisions",
    "original_City": "Canton",
    "original_State": "NC",
    "lat": 35.5328838,
    "lon": -82.8373558
  },
  {
    "original_Store Name": "Modern Prairie",
    "original_City": "Huntington Beach",
    "original_State": "CA",
    "lat": 33.6783336,
    "lon": -118.000016
  },
  {
    "original_Store Name": "Folk Detroit",
    "original_City": "Detroit",
    "original_State": "MI",
    "lat": 42.3315509,
    "lon": -83.0466403
  },
  {
    "original_Store Name": "RockHaus Coffee",
    "original_City": "Fredericksburg",
    "original_State": "TX",
    "lat": 30.2752011,
    "lon": -98.8719843
  },
  {
    "original_Store Name": "Rustic Riverside Mercantile",
    "original_City": "West Point",
    "original_State": "NE",
    "lat": 41.84027,
    "lon": -96.7120725
  },
  {
    "original_Store Name": "ardentgoods.co",
    "original_City": "Pleasanton",
    "original_State": "CA",
    "lat": null,
    "lon": null
  },
  {
    "original_Store Name": "Events with Taste",
    "original_City": "Chattanooga",
    "original_State": "TN",
    "lat": 35.0457219,
    "lon": -85.3094883
  },
  {
    "original_Store Name": "Good Day Shop",
    "original_City": "Madison",
    "original_State": "WI",
    "lat": 43.07469,
    "lon": -89.3841663
  },
  {
    "original_Store Name": "Dwell Home Supply",
    "original_City": "Davidson",
    "original_State": "NC",
    "lat": 35.4992614,
    "lon": -80.8485218
  },
  {
    "original_Store Name": "The Kingfisher & The Queen",
    "original_City": "DAMARISCOTTA",
    "original_State": "ME",
    "lat": 44.0327531,
    "lon": -69.5315214
  },
  {
    "original_Store Name": "The Hens' Kitchen Shoppe",
    "original_City": "Claremont",
    "original_State": "CA",
    "lat": 34.0966764,
    "lon": -117.7197785
  },
  {
    "original_Store Name": "Bakery Nouveau",
    "original_City": "Burien",
    "original_State": "WA",
    "lat": 47.469918,
    "lon": -122.3485274
  },
  {
    "original_Store Name": "The old mill",
    "original_City": "Pigeon Forge",
    "original_State": "TN",
    "lat": 35.7884241,
    "lon": -83.5543329
  },
  {
    "original_Store Name": "HANNI Gallery",
    "original_City": "Harbor Springs",
    "original_State": "MI",
    "lat": 45.431676,
    "lon": -84.991999
  },
  {
    "original_Store Name": "Fraser Wood Elements",
    "original_City": "Fredericksburg",
    "original_State": "VA",
    "lat": 38.3031837,
    "lon": -77.4605399
  },
  {
    "original_Store Name": "BLUEPRINT CT KITCHEN & HOME",
    "original_City": "Litchfield",
    "original_State": "CT",
    "lat": 41.747319,
    "lon": -73.1887243
  },
  {
    "original_Store Name": "Ann Marie's",
    "original_City": "Minocqua",
    "original_State": "WI",
    "lat": 45.871342,
    "lon": -89.710981
  },
  {
    "original_Store Name": "Grayhorse Mercantile",
    "original_City": "Langley",
    "original_State": "WA",
    "lat": 48.0399806,
    "lon": -122.4094051
  },
  {
    "original_Store Name": "The Main Course",
    "original_City": "Fish Creek",
    "original_State": "WI",
    "lat": 45.1277686,
    "lon": -87.2467256
  },
  {
    "original_Store Name": "Lost River Trading Post",
    "original_City": "Capon",
    "original_State": "WV",
    "lat": 39.1362197,
    "lon": -78.4844878
  },
  {
    "original_Store Name": "Aldrich's",
    "original_City": "Port Townsend",
    "original_State": "WA",
    "lat": 48.1179702,
    "lon": -122.769544
  },
  {
    "original_Store Name": "Victoria Fiaretti Creative Design",
    "original_City": "New Kensington",
    "original_State": "PA",
    "lat": 40.5697893,
    "lon": -79.7647705
  },
  {
    "original_Store Name": "Dr.'s Orders 2",
    "original_City": "Ardmore",
    "original_State": "OK",
    "lat": 34.1729273,
    "lon": -97.1309119
  },
  {
    "original_Store Name": "Cheree Berry Paper & Design",
    "original_City": "St. Louis",
    "original_State": "MO",
    "lat": 38.6280278,
    "lon": -90.1910154
  },
  {
    "original_Store Name": "Kitchenwitch",
    "original_City": "Boston",
    "original_State": "MA",
    "lat": 42.3554334,
    "lon": -71.060511
  },
  {
    "original_Store Name": "St. James Cheese Company",
    "original_City": "New Orleans",
    "original_State": "LA",
    "lat": 29.9559145,
    "lon": -90.0730259
  },
  {
    "original_Store Name": "La Cuisine",
    "original_City": "Bozeman",
    "original_State": "MT",
    "lat": 45.6794293,
    "lon": -111.044047
  },
  {
    "original_Store Name": "The Forest Store",
    "original_City": "Broken Bow",
    "original_State": "OK",
    "lat": 34.0298629,
    "lon": -94.7389659
  },
  {
    "original_Store Name": "The Smithy Market & Loft Gallery",
    "original_City": "Washington",
    "original_State": "CT",
    "lat": 41.6314845,
    "lon": -73.3106731
  },
  {
    "original_Store Name": "Palmetto Bluff Real Estate Company",
    "original_City": "Bluffton",
    "original_State": "SC",
    "lat": 32.2371465,
    "lon": -80.8603868
  },
  {
    "original_Store Name": "Jupiter & Main",
    "original_City": "Half Moon Bay",
    "original_State": "CA",
    "lat": 37.4635519,
    "lon": -122.428586
  },
  {
    "original_Store Name": "The Trustees",
    "original_City": "Leominster",
    "original_State": "MA",
    "lat": 42.5267443,
    "lon": -71.7614891
  },
  {
    "original_Store Name": "Jack and Adeline",
    "original_City": "Tacoma",
    "original_State": "WA",
    "lat": 47.2455013,
    "lon": -122.438329
  },
  {
    "original_Store Name": "Bohemian Crown LLC DBA Season and Stir",
    "original_City": "Rochester Hills",
    "original_State": "MI",
    "lat": 42.6583661,
    "lon": -83.1499322
  },
  {
    "original_Store Name": "margo r roberts",
    "original_City": "Minneapolis",
    "original_State": "MN",
    "lat": 44.9772995,
    "lon": -93.2654692
  },
  {
    "original_Store Name": "the kitchen at Alamo hardware",
    "original_City": "Alamo",
    "original_State": "CA",
    "lat": 37.8502033,
    "lon": -122.032184
  },
  {
    "original_Store Name": "Athens Cooks",
    "original_City": "Athens",
    "original_State": "GA",
    "lat": 33.9597677,
    "lon": -83.376398
  },
  {
    "original_Store Name": "Foliahōm",
    "original_City": "Jacksonville",
    "original_State": "FL",
    "lat": 30.3321838,
    "lon": -81.655651
  },
  {
    "original_Store Name": "The White Barn Company",
    "original_City": "Decatur",
    "original_State": "IN",
    "lat": 40.830603,
    "lon": -84.9291329
  },
  {
    "original_Store Name": "COA Collective",
    "original_City": "Reno",
    "original_State": "NV",
    "lat": 39.5261788,
    "lon": -119.812658
  },
  {
    "original_Store Name": "16 HANDS",
    "original_City": "Ann Arbor",
    "original_State": "MI",
    "lat": 42.2813722,
    "lon": -83.7484616
  },
  {
    "original_Store Name": "SUSU Dessert Bar",
    "original_City": "Seattle",
    "original_State": "WA",
    "lat": 47.6038321,
    "lon": -122.330062
  },
  {
    "original_Store Name": "Lewis & Louise",
    "original_City": "Oakland",
    "original_State": "CA",
    "lat": 37.8044557,
    "lon": -122.271356
  },
  {
    "original_Store Name": "SALT",
    "original_City": "Sausalito",
    "original_State": "CA",
    "lat": 37.8590272,
    "lon": -122.485469
  },
  {
    "original_Store Name": "The Garden Cafe and Marketplace",
    "original_City": "York",
    "original_State": "SC",
    "lat": 34.9940654,
    "lon": -81.2421403
  },
  {
    "original_Store Name": "Spilt Milk Pastry",
    "original_City": "Oak Park",
    "original_State": "IL",
    "lat": 41.8878145,
    "lon": -87.7887615
  },
  {
    "original_Store Name": "The China Grove",
    "original_City": "Groveland",
    "original_State": "MA",
    "lat": 42.7598804,
    "lon": -71.0318212
  },
  {
    "original_Store Name": "Candle Makers On the Square",
    "original_City": "Bowling Green",
    "original_State": "KY",
    "lat": 36.9929203,
    "lon": -86.4428677
  },
  {
    "original_Store Name": "Jewell & Jane Co",
    "original_City": "Lebanon",
    "original_State": "TN",
    "lat": 36.2079779,
    "lon": -86.2910945
  },
  {
    "original_Store Name": "Willow & Grace Home LLC",
    "original_City": "Quakertown",
    "original_State": "PA",
    "lat": 40.4417682,
    "lon": -75.3415667
  },
  {
    "original_Store Name": "Wise Ant General Store and Bakery",
    "original_City": "Ardmore",
    "original_State": "TN",
    "lat": 34.9922618,
    "lon": -86.8436773
  },
  {
    "original_Store Name": "MP Dawson Mercantile",
    "original_City": "Oneonta",
    "original_State": "AL",
    "lat": 33.9481537,
    "lon": -86.472764
  },
  {
    "original_Store Name": "Mes Amies",
    "original_City": "McMinnville",
    "original_State": "OR",
    "lat": 45.2100367,
    "lon": -123.194463
  },
  {
    "original_Store Name": "The Dirty Apron",
    "original_City": "Anchorage AK, 99503",
    "original_State": "AK",
    "lat": 61.1884229,
    "lon": -149.8975908
  },
  {
    "original_Store Name": "Vessel",
    "original_City": "Denver",
    "original_State": "CO",
    "lat": 39.7392364,
    "lon": -104.984862
  },
  {
    "original_Store Name": "Evelyn Taylor Avenue",
    "original_City": "McMinnville ",
    "original_State": "TN",
    "lat": 35.683404,
    "lon": -85.7699816
  },
  {
    "original_Store Name": "South of Hampton",
    "original_City": "Atlanta",
    "original_State": "GA",
    "lat": 33.7544657,
    "lon": -84.3898151
  },
  {
    "original_Store Name": "The Cupboard Collective",
    "original_City": "Gallatin",
    "original_State": "TN",
    "lat": 36.3883031,
    "lon": -86.4475898
  },
  {
    "original_Store Name": "Lariat Coffee Roasters",
    "original_City": "Winthrop",
    "original_State": "WA",
    "lat": 48.4779232,
    "lon": -120.186195
  },
  {
    "original_Store Name": "Phoenix Hardwoods",
    "original_City": "Floyd",
    "original_State": "VA",
    "lat": 36.9112443,
    "lon": -80.3200502
  },
  {
    "original_Store Name": "The White Rabbit Market",
    "original_City": "Quincy",
    "original_State": "FL",
    "lat": 30.5889265,
    "lon": -84.5762388
  },
  {
    "original_Store Name": "Wanderful Boxes",
    "original_City": "Tucson",
    "original_State": "AZ",
    "lat": 32.2228765,
    "lon": -110.974847
  },
  {
    "original_Store Name": "Small Town Collective",
    "original_City": "Victoria",
    "original_State": "BC",
    "lat": 48.4283182,
    "lon": -123.364953
  },
  {
    "original_Store Name": "Le Petit Outre",
    "original_City": "Missoula",
    "original_State": "MT",
    "lat": 46.8701049,
    "lon": -113.995267
  },
  {
    "original_Store Name": "Manse",
    "original_City": "Washington",
    "original_State": "DC",
    "lat": 38.8950368,
    "lon": -77.0365427
  },
  {
    "original_Store Name": "Uniquely Lyons / Solace",
    "original_City": "Lyons",
    "original_State": "CO",
    "lat": 40.224432,
    "lon": -105.270532
  },
  {
    "original_Store Name": "Sloomb",
    "original_City": "Belton",
    "original_State": "TX",
    "lat": 31.0560132,
    "lon": -97.464453
  },
  {
    "original_Store Name": "The Blue Peony",
    "original_City": "Langley",
    "original_State": "WA",
    "lat": 48.0399806,
    "lon": -122.4094051
  },
  {
    "original_Store Name": "Heart & Home Design Co.",
    "original_City": "Topeka",
    "original_State": "KS",
    "lat": 39.049011,
    "lon": -95.677556
  },
  {
    "original_Store Name": "Babylon Mercantile",
    "original_City": "Babylon",
    "original_State": "NY",
    "lat": 40.6956552,
    "lon": -73.3256753
  },
  {
    "original_Store Name": "Well Gifted",
    "original_City": "Fort Worth",
    "original_State": "TX",
    "lat": 32.753177,
    "lon": -97.3327459
  },
  {
    "original_Store Name": "Sweetwater a flower market",
    "original_City": "Colorado Springs",
    "original_State": "CO",
    "lat": 38.8339578,
    "lon": -104.825348
  },
  {
    "original_Store Name": "The Sydney House",
    "original_City": "Nashotah",
    "original_State": "WI",
    "lat": 43.0979818,
    "lon": -88.4026935
  },
  {
    "original_Store Name": "Cedar Swan Woodshop",
    "original_City": "Nevis",
    "original_State": "MN",
    "lat": 46.9651482,
    "lon": -94.8395533
  },
  {
    "original_Store Name": "Wild Hog Country Market",
    "original_City": "Stratford",
    "original_State": "ON",
    "lat": 43.3700899,
    "lon": -80.9818016
  },
  {
    "original_Store Name": "Storia Home",
    "original_City": "Sebastopol",
    "original_State": "CA",
    "lat": 38.4021038,
    "lon": -122.824222
  },
  {
    "original_Store Name": "Isadora Popper",
    "original_City": "Clayton",
    "original_State": "GA",
    "lat": 34.8781479,
    "lon": -83.4009933
  },
  {
    "original_Store Name": "The Corner",
    "original_City": "Flemington",
    "original_State": "NJ",
    "lat": 40.5130953,
    "lon": -74.8591333
  },
  {
    "original_Store Name": "Mix Design Store",
    "original_City": "Guilford",
    "original_State": "CT",
    "lat": 41.2827593,
    "lon": -72.6816365
  },
  {
    "original_Store Name": "Anaway",
    "original_City": "Richland Center",
    "original_State": "WI",
    "lat": 43.3355298,
    "lon": -90.3854141
  },
  {
    "original_Store Name": "The Cheese Lady Rochester",
    "original_City": "Rochester",
    "original_State": "MI",
    "lat": 42.680588,
    "lon": -83.1338214
  },
  {
    "original_Store Name": "The Kitchen",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Santa Ynez General",
    "original_City": "Santa Ynez",
    "original_State": "CA",
    "lat": 34.6128792,
    "lon": -120.0817357
  },
  {
    "original_Store Name": "F.T. Brown Merchantile & Marine Chandlery Co.",
    "original_City": "Mount Desert",
    "original_State": "ME",
    "lat": 44.2937483,
    "lon": -68.2890678
  },
  {
    "original_Store Name": "Sower",
    "original_City": "Chattanooga ",
    "original_State": "TN",
    "lat": 35.0457219,
    "lon": -85.3094883
  },
  {
    "original_Store Name": "Orson H Gygi Co",
    "original_City": "South Salt Lake",
    "original_State": "UT",
    "lat": 40.7074741,
    "lon": -111.88827
  },
  {
    "original_Store Name": "Slow North",
    "original_City": "Austin",
    "original_State": "TX",
    "lat": 30.2711286,
    "lon": -97.7436995
  },
  {
    "original_Store Name": "The Happy Hensters",
    "original_City": "Winchester",
    "original_State": "KY",
    "lat": 37.990079,
    "lon": -84.1796503
  },
  {
    "original_Store Name": "Bear Hollow Wood Carvers",
    "original_City": "French Lick Township",
    "original_State": "IN",
    "lat": 38.548399,
    "lon": -86.621388
  },
  {
    "original_Store Name": "Acorn Bluff Farms",
    "original_City": "Columbus Junction",
    "original_State": "IA",
    "lat": 41.2791892,
    "lon": -91.3613798
  },
  {
    "original_Store Name": "Not Too Shabby",
    "original_City": "Folsom",
    "original_State": "CA",
    "lat": 38.6779591,
    "lon": -121.176058
  },
  {
    "original_Store Name": "Cotton-Top Pastries",
    "original_City": "Helena",
    "original_State": "MT",
    "lat": 46.5927425,
    "lon": -112.036277
  },
  {
    "original_Store Name": "Stratford Hall Gift Shop",
    "original_City": "Stratford",
    "original_State": "VA",
    "lat": 39.0968926,
    "lon": -77.5583413
  },
  {
    "original_Store Name": "Of Land And Sea Co.",
    "original_City": "Elk Grove",
    "original_State": "CA",
    "lat": 38.4087993,
    "lon": -121.3716178
  },
  {
    "original_Store Name": "Brooklyn ARTery",
    "original_City": "Brooklyn",
    "original_State": "NY",
    "lat": 40.6526006,
    "lon": -73.9497211
  },
  {
    "original_Store Name": "PLC Meat Co",
    "original_City": "Borger",
    "original_State": "TX",
    "lat": 35.6689767,
    "lon": -101.3919481
  },
  {
    "original_Store Name": "Le Pommier",
    "original_City": "Santa Fe",
    "original_State": "NM",
    "lat": 35.6876096,
    "lon": -105.938456
  },
  {
    "original_Store Name": "Eden's Way",
    "original_City": "Center Township",
    "original_State": "IN",
    "lat": 41.3888487,
    "lon": -87.3640909698784
  },
  {
    "original_Store Name": "Trunk Show",
    "original_City": "Denver",
    "original_State": "CO",
    "lat": 39.7392364,
    "lon": -104.984862
  },
  {
    "original_Store Name": "Community Creative Center",
    "original_City": "Fayetteville",
    "original_State": "AR",
    "lat": 36.0625843,
    "lon": -94.1574328
  },
  {
    "original_Store Name": "Modera Studio",
    "original_City": "Senoia",
    "original_State": "GA",
    "lat": 33.3011663,
    "lon": -84.5540046
  },
  {
    "original_Store Name": "1811Shop & Bar Room",
    "original_City": "Brecksville",
    "original_State": "OH",
    "lat": 41.3197763,
    "lon": -81.6267904
  },
  {
    "original_Store Name": "Minglement Marketplace - Est.1972",
    "original_City": "Vashon",
    "original_State": "WA",
    "lat": 47.4480496,
    "lon": -122.46067
  },
  {
    "original_Store Name": "Alaska Wooden Spoon Company LLC",
    "original_City": "Anchorage",
    "original_State": "AK",
    "lat": 61.2163129,
    "lon": -149.894852
  },
  {
    "original_Store Name": "KD BIEL",
    "original_City": "Dallas",
    "original_State": "TX",
    "lat": 32.7762719,
    "lon": -96.7968559
  },
  {
    "original_Store Name": "Fancies Bakery and General Store",
    "original_City": "Corrales",
    "original_State": "NM",
    "lat": 35.2382346,
    "lon": -106.6069727
  },
  {
    "original_Store Name": "Hoot and Howl",
    "original_City": "Morgantown",
    "original_State": "WV",
    "lat": 39.6296809,
    "lon": -79.9559437
  },
  {
    "original_Store Name": "Atelier:  A Boutique Gallery",
    "original_City": "Pottstown",
    "original_State": "PA",
    "lat": 40.2452976,
    "lon": -75.6496424
  },
  {
    "original_Store Name": "Barn House Studio",
    "original_City": "Central City",
    "original_State": "KY",
    "lat": 37.2939322,
    "lon": -87.1233292
  },
  {
    "original_Store Name": "Sea Escape",
    "original_City": "Surf City",
    "original_State": "NJ",
    "lat": 39.6587349,
    "lon": -74.168292
  },
  {
    "original_Store Name": "Project Sweetsun",
    "original_City": "Hot Springs",
    "original_State": "AZ",
    "lat": 32.9983944,
    "lon": -109.9006382
  },
  {
    "original_Store Name": "Farmington Local Market",
    "original_City": "Tullahoma",
    "original_State": "TN",
    "lat": 35.3624915,
    "lon": -86.2099766
  },
  {
    "original_Store Name": "Fig Garden",
    "original_City": "San Ansalmo",
    "original_State": "CA",
    "lat": 36.79772,
    "lon": -119.807555
  },
  {
    "original_Store Name": "Podunk's",
    "original_City": "Somerville",
    "original_State": "TN",
    "lat": 35.2436969,
    "lon": -89.3500714
  },
  {
    "original_Store Name": "Mediterranean Table (Marials)",
    "original_City": "Buckeye",
    "original_State": "AZ",
    "lat": 33.3703197,
    "lon": -112.583776
  },
  {
    "original_Store Name": "Hive Supply Co.",
    "original_City": "Arroyo Grande",
    "original_State": "CA",
    "lat": 35.1235374,
    "lon": -120.5785796
  },
  {
    "original_Store Name": "Scrumptious Secrets",
    "original_City": "Chester",
    "original_State": "NJ",
    "lat": 40.7842667,
    "lon": -74.6968284
  },
  {
    "original_Store Name": "Park City Gift & Gourmet",
    "original_City": "Park City",
    "original_State": "UT",
    "lat": 40.6460921,
    "lon": -111.4979963
  },
  {
    "original_Store Name": "Fig & Sparrow",
    "original_City": "Saint Charles",
    "original_State": "MO",
    "lat": 38.783855,
    "lon": -90.481677
  },
  {
    "original_Store Name": "Kitchen Collage of Des Moines",
    "original_City": "Lee",
    "original_State": "IA",
    "lat": 41.5878,
    "lon": -93.6128
  },
  {
    "original_Store Name": "Dream Gift Shop",
    "original_City": "Yuma",
    "original_State": "AZ",
    "lat": 32.7253096,
    "lon": -114.6188787
  },
  {
    "original_Store Name": "SISTAIN",
    "original_City": "Columbus",
    "original_State": "OH",
    "lat": 39.9622601,
    "lon": -83.0007065
  },
  {
    "original_Store Name": "Blluum",
    "original_City": "Ooltewah",
    "original_State": "TN",
    "lat": 35.071039,
    "lon": -85.056255
  },
  {
    "original_Store Name": "The Shopkeep Co.",
    "original_City": "New Albany",
    "original_State": "MS",
    "lat": 34.4942683,
    "lon": -89.0078418
  },
  {
    "original_Store Name": "The Ash House",
    "original_City": "Akron",
    "original_State": "OH",
    "lat": 41.083064,
    "lon": -81.518485
  },
  {
    "original_Store Name": "East Chateau",
    "original_City": "Hudson",
    "original_State": "FL",
    "lat": 28.3617709,
    "lon": -82.6932847
  },
  {
    "original_Store Name": "Goose Farms Dry Goods",
    "original_City": "Columbus",
    "original_State": "OH",
    "lat": 39.9622601,
    "lon": -83.0007065
  },
  {
    "original_Store Name": "Alpenglö Living",
    "original_City": "Leavenworth",
    "original_State": "WA",
    "lat": 47.5969138,
    "lon": -120.661081
  },
  {
    "original_Store Name": "The Sentinel",
    "original_City": "Marfa",
    "original_State": "TX",
    "lat": 30.3117621,
    "lon": -104.023146
  },
  {
    "original_Store Name": "Baa Baazaar",
    "original_City": "Toronto",
    "original_State": "ON",
    "lat": 43.6534817,
    "lon": -79.3839347
  },
  {
    "original_Store Name": "CHEFS PANTRY",
    "original_City": "Brock",
    "original_State": "TX",
    "lat": 32.6762432,
    "lon": -97.9408718
  },
  {
    "original_Store Name": "Grae Studio",
    "original_City": "Fulton",
    "original_State": "MO",
    "lat": 38.8467082,
    "lon": -91.9479586
  },
  {
    "original_Store Name": "Faire Living",
    "original_City": "Calgary",
    "original_State": "AB",
    "lat": 51.0456064,
    "lon": -114.057541
  },
  {
    "original_Store Name": "Dune Gift and Home",
    "original_City": "Stoughton",
    "original_State": "WI",
    "lat": 42.9167389,
    "lon": -89.2178997
  },
  {
    "original_Store Name": "CoLab Kitchen",
    "original_City": "Stuart",
    "original_State": "FL",
    "lat": 27.197983,
    "lon": -80.2519175
  },
  {
    "original_Store Name": "archer + pratt",
    "original_City": "Franklinton",
    "original_State": "NC",
    "lat": 36.1018163,
    "lon": -78.4580543
  },
  {
    "original_Store Name": "The Whale Wins",
    "original_City": "Seattle",
    "original_State": "WA",
    "lat": 47.6038321,
    "lon": -122.330062
  },
  {
    "original_Store Name": "Common Crow Natural Market",
    "original_City": "Gloucester",
    "original_State": "MA",
    "lat": 42.6153595,
    "lon": -70.6624608
  },
  {
    "original_Store Name": "Amy Cowling",
    "original_City": "Atlanta",
    "original_State": "TX",
    "lat": 33.1162131,
    "lon": -94.1663493
  },
  {
    "original_Store Name": "Chipley Packing, Co dba Stone's Meats",
    "original_City": "Chipley",
    "original_State": "FL",
    "lat": 30.7818584,
    "lon": -85.538541
  },
  {
    "original_Store Name": "Gathering Grounds",
    "original_City": "Perham",
    "original_State": "MN",
    "lat": 46.5944042,
    "lon": -95.5725415
  },
  {
    "original_Store Name": "Few of a Kind Vintage + Mercantile",
    "original_City": "Niwot",
    "original_State": "CO",
    "lat": 40.103874,
    "lon": -105.170819
  },
  {
    "original_Store Name": "Cath-Lene’s",
    "original_City": "Parsons",
    "original_State": "TN",
    "lat": 35.649791,
    "lon": -88.1267025
  },
  {
    "original_Store Name": "Prairie General",
    "original_City": "Indianapolis",
    "original_State": "IN",
    "lat": 39.7683331,
    "lon": -86.1583502
  },
  {
    "original_Store Name": "Abbye Grey",
    "original_City": "Madison ",
    "original_State": "MS",
    "lat": 32.4618086,
    "lon": -90.1153638
  },
  {
    "original_Store Name": "Adam Rhein",
    "original_City": "New York",
    "original_State": "NY",
    "lat": 40.7127281,
    "lon": -74.0060152
  },
  {
    "original_Store Name": "Newfound Artisan",
    "original_City": "Brevard",
    "original_State": "NC",
    "lat": 35.2334472,
    "lon": -82.7342919
  },
  {
    "original_Store Name": "Reclaimed Woodworks",
    "original_City": "Canon City",
    "original_State": "CO",
    "lat": 38.4422506,
    "lon": -105.2348795
  },
  {
    "original_Store Name": "Hiwasse Mercantile",
    "original_City": "Hiwasse",
    "original_State": "AR",
    "lat": 36.4317426,
    "lon": -94.3338218
  },
  {
    "original_Store Name": "Alchemist's Jam LLC",
    "original_City": "McMinnville",
    "original_State": "OR",
    "lat": 45.2100367,
    "lon": -123.194463
  },
  {
    "original_Store Name": "A Maker's Circle",
    "original_City": "Bedminster",
    "original_State": "NJ",
    "lat": 40.6741476,
    "lon": -74.6809503
  },
  {
    "original_Store Name": "Corduroy",
    "original_City": "Denver",
    "original_State": "CO",
    "lat": 39.7392364,
    "lon": -104.984862
  },
  {
    "original_Store Name": "Madam Clutterbucket's Neurodiverse Universe",
    "original_City": "BLACK MOUNTAIN",
    "original_State": "NC",
    "lat": 35.6176544,
    "lon": -82.3205791
  },
  {
    "original_Store Name": "Frozen Farmers Co.",
    "original_City": "Hancock ",
    "original_State": "MI",
    "lat": 47.126871,
    "lon": -88.580956
  },
  {
    "original_Store Name": "Hundred Acres Shop",
    "original_City": "Rockport",
    "original_State": "ME",
    "lat": 44.1875416,
    "lon": -69.0730466
  },
  {
    "original_Store Name": "Linen and Clove",
    "original_City": "Verona",
    "original_State": "WI",
    "lat": 42.9905492,
    "lon": -89.5335575
  },
  {
    "original_Store Name": "Catchpenny",
    "original_City": "Alton",
    "original_State": "NH",
    "lat": 43.4563663,
    "lon": -71.2213228
  },
  {
    "original_Store Name": "Eola Crest Cattle",
    "original_City": "McMinnville",
    "original_State": "OR",
    "lat": 45.2100367,
    "lon": -123.194463
  },
  {
    "original_Store Name": "Bird's Nest Cafe & Night Hawks Diner",
    "original_City": "Washington Township",
    "original_State": "IN",
    "lat": 39.02147565,
    "lon": -84.9677121109565
  },
  {
    "original_Store Name": "Pinch & Pour",
    "original_City": "Fargo",
    "original_State": "ND",
    "lat": 46.877229,
    "lon": -96.789821
  },
  {
    "original_Store Name": "Amber Falls Winery Nashville",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Thyme In Your Kitchen",
    "original_City": "Sharon",
    "original_State": "PA",
    "lat": 41.232947,
    "lon": -80.5078056
  },
  {
    "original_Store Name": "Wine & Roses",
    "original_City": "Lodi",
    "original_State": "CA",
    "lat": 38.1342805,
    "lon": -121.2736022
  },
  {
    "original_Store Name": "Mother Hubbard's Cupboard",
    "original_City": "Girdwood",
    "original_State": "AK",
    "lat": 60.9632459,
    "lon": -149.1336969
  },
  {
    "original_Store Name": "Cool Vintage Watches",
    "original_City": "Parkville",
    "original_State": "MO",
    "lat": 39.1896268,
    "lon": -94.6826891
  },
  {
    "original_Store Name": "Koontz Dezignz",
    "original_City": "Middletown",
    "original_State": "CA",
    "lat": 38.7524045,
    "lon": -122.614985
  },
  {
    "original_Store Name": "Eclectic Energy, LLC",
    "original_City": "South Kingstown",
    "original_State": "RI",
    "lat": 41.454944,
    "lon": -71.5394738
  },
  {
    "original_Store Name": "The Amish House Handcrafted Furniture",
    "original_City": "Nolensville",
    "original_State": "TN",
    "lat": 35.9522852,
    "lon": -86.6694413
  },
  {
    "original_Store Name": "Poppy & Hawk",
    "original_City": "Camas",
    "original_State": "WA",
    "lat": 45.5863014,
    "lon": -122.403277
  },
  {
    "original_Store Name": "La Petite Maison Antiques",
    "original_City": "Draper",
    "original_State": "UT",
    "lat": 40.5247777,
    "lon": -111.8627989
  },
  {
    "original_Store Name": "Mateos Day Spa",
    "original_City": "Colorado Springs",
    "original_State": "CO",
    "lat": 38.8339578,
    "lon": -104.825348
  },
  {
    "original_Store Name": "Martin Mattox",
    "original_City": "Auburn",
    "original_State": "CA",
    "lat": 38.8945939,
    "lon": -121.0739897
  },
  {
    "original_Store Name": "Birdies Market",
    "original_City": "Marble Falls",
    "original_State": "TX",
    "lat": 30.5777511,
    "lon": -98.2756505
  },
  {
    "original_Store Name": "The Paris Market",
    "original_City": "Bluffton",
    "original_State": "SC",
    "lat": 32.2371465,
    "lon": -80.8603868
  },
  {
    "original_Store Name": "Thress Nursery Gardens",
    "original_City": "Knoxville",
    "original_State": "TN",
    "lat": 35.9603948,
    "lon": -83.9210261
  },
  {
    "original_Store Name": "Honey Door Co",
    "original_City": "St Louis",
    "original_State": "MO",
    "lat": 38.6280278,
    "lon": -90.1910154
  },
  {
    "original_Store Name": "Main Street Merchants 208 N Main",
    "original_City": "Conroe",
    "original_State": "TX",
    "lat": 30.3118769,
    "lon": -95.4560512
  },
  {
    "original_Store Name": "Molly Singer Design",
    "original_City": "Pittsburgh",
    "original_State": "PA",
    "lat": 40.4416941,
    "lon": -79.9900861
  },
  {
    "original_Store Name": "Philo Ridge Farm",
    "original_City": "Charlotte",
    "original_State": "VT",
    "lat": 44.3105141,
    "lon": -73.2531419
  },
  {
    "original_Store Name": "HOUSE OF ASHER",
    "original_City": "Moorpark",
    "original_State": "CA",
    "lat": 34.285558,
    "lon": -118.8820414
  },
  {
    "original_Store Name": "Myth & Ink",
    "original_City": "Piedmont",
    "original_State": "SD",
    "lat": 44.231653,
    "lon": -103.3890753
  },
  {
    "original_Store Name": "Hilltop Haus",
    "original_City": "Running springs",
    "original_State": "CA",
    "lat": 34.2077859,
    "lon": -117.109204
  },
  {
    "original_Store Name": "Read Between The Lines",
    "original_City": "Plano",
    "original_State": "TX",
    "lat": 33.0136764,
    "lon": -96.6925096
  },
  {
    "original_Store Name": "Bumble's Dry Goods",
    "original_City": "Chelsea",
    "original_State": "MI",
    "lat": 42.3180163,
    "lon": -84.020224
  },
  {
    "original_Store Name": "Bliss",
    "original_City": "Ellsworth",
    "original_State": "ME",
    "lat": 44.5414596,
    "lon": -68.4243599
  },
  {
    "original_Store Name": "The Vintage Gentlemen",
    "original_City": "St. Augustine",
    "original_State": "FL",
    "lat": 29.8946952,
    "lon": -81.3145395
  },
  {
    "original_Store Name": "Serge + Jane",
    "original_City": "Edina",
    "original_State": "MN",
    "lat": 44.8897027,
    "lon": -93.3501222
  },
  {
    "original_Store Name": "Modern Merchant",
    "original_City": "Sheridan",
    "original_State": "WY",
    "lat": 44.797194,
    "lon": -106.956179
  },
  {
    "original_Store Name": "Potomac River Interiors",
    "original_City": "Frederick",
    "original_State": "MD",
    "lat": 39.415779,
    "lon": -77.4127562
  },
  {
    "original_Store Name": "Poppy's",
    "original_City": "Brooklyn",
    "original_State": "NY",
    "lat": 40.6526006,
    "lon": -73.9497211
  },
  {
    "original_Store Name": "Robin’s Cozy Nest",
    "original_City": "Franklin",
    "original_State": "TN",
    "lat": 35.925206,
    "lon": -86.8689419
  },
  {
    "original_Store Name": "The Boho Depot",
    "original_City": "Winston-Salem",
    "original_State": "NC",
    "lat": 36.0998131,
    "lon": -80.2440518
  },
  {
    "original_Store Name": "Firefly Outfitters LLC",
    "original_City": "Sister Bay",
    "original_State": "WI",
    "lat": 45.1883097,
    "lon": -87.1220804
  },
  {
    "original_Store Name": "Harwood Gold",
    "original_City": "Ajax",
    "original_State": "ON",
    "lat": 43.8505287,
    "lon": -79.0208814
  },
  {
    "original_Store Name": "Little Willow Mercantile",
    "original_City": "DeRidder",
    "original_State": "LA",
    "lat": 30.846201,
    "lon": -93.289281
  },
  {
    "original_Store Name": "The DIME Store",
    "original_City": "Denton",
    "original_State": "TX",
    "lat": 33.2150386,
    "lon": -97.1330516
  },
  {
    "original_Store Name": "Homesong Market",
    "original_City": "Kansas City",
    "original_State": "MO",
    "lat": 39.100105,
    "lon": -94.5781416
  },
  {
    "original_Store Name": "Old Main Mercantile",
    "original_City": "Starkville",
    "original_State": "MS",
    "lat": 33.4638745,
    "lon": -88.8152074
  },
  {
    "original_Store Name": "Kudzu Bakery Mt Pleasant",
    "original_City": "Mount Pleasant",
    "original_State": "SC",
    "lat": 32.7940651,
    "lon": -79.8625851
  },
  {
    "original_Store Name": "Iris and Oak Gallery & Gifts, LLC",
    "original_City": "Durand",
    "original_State": "WI",
    "lat": 44.6283703,
    "lon": -91.9676627
  },
  {
    "original_Store Name": "The Prepared Table Kitchen Shop",
    "original_City": "Tallahassee",
    "original_State": "FL",
    "lat": 30.4380832,
    "lon": -84.2809332
  },
  {
    "original_Store Name": "Delta Mind Body Center",
    "original_City": "Sacramento",
    "original_State": "CA",
    "lat": 38.5810606,
    "lon": -121.493895
  },
  {
    "original_Store Name": "Peck & Bushel Fruit Company",
    "original_City": "Erin",
    "original_State": "WI",
    "lat": 43.2546475,
    "lon": -88.3691701
  },
  {
    "original_Store Name": "The Mercantile at Three Crosses",
    "original_City": "Powhatan",
    "original_State": "VA",
    "lat": 37.5420237,
    "lon": -77.9190619
  },
  {
    "original_Store Name": "Cellar Door",
    "original_City": "Ipswich",
    "original_State": "MA",
    "lat": 42.679273,
    "lon": -70.8411583
  },
  {
    "original_Store Name": "Gamble House Bookstore",
    "original_City": "Pasadena",
    "original_State": "CA",
    "lat": 34.1476507,
    "lon": -118.144155
  },
  {
    "original_Store Name": "Fetch Mkt.",
    "original_City": "Ridgeland",
    "original_State": "SC",
    "lat": 32.4807435,
    "lon": -80.980386
  },
  {
    "original_Store Name": "BirdieThatcher/Red Rooster, inc",
    "original_City": "Missoula",
    "original_State": "MT",
    "lat": 46.8701049,
    "lon": -113.995267
  },
  {
    "original_Store Name": "Savoir Faire Home",
    "original_City": "Andover",
    "original_State": "MA",
    "lat": 42.65717,
    "lon": -71.1408776
  },
  {
    "original_Store Name": "Vital Industries",
    "original_City": "Rhinelander",
    "original_State": "WI",
    "lat": 45.636623,
    "lon": -89.412075
  },
  {
    "original_Store Name": "KitchenWares by Blackstones",
    "original_City": "Boston",
    "original_State": "MA",
    "lat": 42.3554334,
    "lon": -71.060511
  },
  {
    "original_Store Name": "The Filling Station",
    "original_City": "Berkeley",
    "original_State": "CA",
    "lat": 37.8708393,
    "lon": -122.272863
  },
  {
    "original_Store Name": "Warner Public Market",
    "original_City": "Warner",
    "original_State": "NH",
    "lat": 43.2809477,
    "lon": -71.8164258
  },
  {
    "original_Store Name": "Rolling Blades",
    "original_City": "Scottsville",
    "original_State": "KY",
    "lat": 36.7533781,
    "lon": -86.1905424
  },
  {
    "original_Store Name": "Little Brick",
    "original_City": "Edmonton",
    "original_State": "AB",
    "lat": 53.5462055,
    "lon": -113.491241
  },
  {
    "original_Store Name": "loop and tie",
    "original_City": "Carrollton",
    "original_State": "TX",
    "lat": 32.9515472,
    "lon": -96.9034244
  },
  {
    "original_Store Name": "Aurum Ethos",
    "original_City": "Mount Airy",
    "original_State": "MD",
    "lat": 39.3765918,
    "lon": -77.1549078
  },
  {
    "original_Store Name": "Lexie and Lee",
    "original_City": "LYNCHBURG",
    "original_State": "VA",
    "lat": 37.4137536,
    "lon": -79.1422464
  },
  {
    "original_Store Name": "The Hive and Co.",
    "original_City": "Franklin",
    "original_State": "TN",
    "lat": 35.925206,
    "lon": -86.8689419
  },
  {
    "original_Store Name": "Rock Bottom Soap",
    "original_City": "London",
    "original_State": "KY",
    "lat": 37.1283343,
    "lon": -84.0835576
  },
  {
    "original_Store Name": "Marshall Goods",
    "original_City": "Durham ",
    "original_State": "NC",
    "lat": 35.996653,
    "lon": -78.9018053
  },
  {
    "original_Store Name": "The Rooted Market",
    "original_City": "Mount Olive",
    "original_State": "NC",
    "lat": 35.1965532,
    "lon": -78.0663788
  },
  {
    "original_Store Name": "Dirt Road Candle Co",
    "original_City": "Lewis",
    "original_State": "IA",
    "lat": 41.3060045,
    "lon": -95.0892282
  },
  {
    "original_Store Name": "Huset",
    "original_City": "Venice",
    "original_State": "CA",
    "lat": 33.995044,
    "lon": -118.4668875
  },
  {
    "original_Store Name": "The Pasta Market",
    "original_City": "Blue Ridge",
    "original_State": "GA",
    "lat": 34.863972,
    "lon": -84.324087
  },
  {
    "original_Store Name": "Mabel Bakery",
    "original_City": "Asheville",
    "original_State": "NC",
    "lat": 35.595363,
    "lon": -82.5508407
  },
  {
    "original_Store Name": "The Lost River General Store",
    "original_City": "Lost City",
    "original_State": "WV",
    "lat": 38.9307638,
    "lon": -78.8338255
  },
  {
    "original_Store Name": "Spoon + hook and Haunt by spoon + hook",
    "original_City": "Asheville",
    "original_State": "NC",
    "lat": 35.595363,
    "lon": -82.5508407
  },
  {
    "original_Store Name": "Abode",
    "original_City": "GRENADA",
    "original_State": "MS",
    "lat": 33.7848667,
    "lon": -89.8025901
  },
  {
    "original_Store Name": "Vida Verde Home",
    "original_City": "Stanwood",
    "original_State": "WA",
    "lat": 48.24216,
    "lon": -122.3520327
  },
  {
    "original_Store Name": "Commodore Hotel & Cafe",
    "original_City": "Linden",
    "original_State": "TN",
    "lat": 35.6172918,
    "lon": -87.8394705
  },
  {
    "original_Store Name": "May Hardware",
    "original_City": "McCall",
    "original_State": "ID",
    "lat": 44.9110458,
    "lon": -116.098281
  },
  {
    "original_Store Name": "Gardenhouse Studio",
    "original_City": "Waxahachie",
    "original_State": "TX",
    "lat": 32.3944908,
    "lon": -96.8439365
  },
  {
    "original_Store Name": "The French Farmhouse Home Market",
    "original_City": "Roanoke",
    "original_State": "VA",
    "lat": 37.270973,
    "lon": -79.9414313
  },
  {
    "original_Store Name": "Landmark Creamery Provisions",
    "original_City": "Belleville",
    "original_State": "WI",
    "lat": 42.8596864,
    "lon": -89.5346023
  },
  {
    "original_Store Name": "Dawn Berry",
    "original_City": "Palm Springs",
    "original_State": "CA",
    "lat": 33.8246269,
    "lon": -116.540303
  },
  {
    "original_Store Name": "Georgetown Pottery",
    "original_City": "Georgetown",
    "original_State": "ME",
    "lat": 43.8042909,
    "lon": -69.7555099
  },
  {
    "original_Store Name": "The Cupboard",
    "original_City": "Decatur",
    "original_State": "AL",
    "lat": 34.6060203,
    "lon": -86.9838165
  },
  {
    "original_Store Name": "Hudson Bradley Boutique",
    "original_City": "Ponte Vedra Beach",
    "original_State": "FL",
    "lat": 30.2396865,
    "lon": -81.3856384
  },
  {
    "original_Store Name": "Rare Assembly",
    "original_City": "Los Angeles",
    "original_State": "CA",
    "lat": 34.0536909,
    "lon": -118.242766
  },
  {
    "original_Store Name": "Mercantile and Mash",
    "original_City": "Charleston",
    "original_State": "SC",
    "lat": 32.7884363,
    "lon": -79.9399309
  },
  {
    "original_Store Name": "Say Grace",
    "original_City": "SOUTHFIELD",
    "original_State": "MI",
    "lat": 42.4733689,
    "lon": -83.2218731
  },
  {
    "original_Store Name": "Fount Board & Table",
    "original_City": "Dallas",
    "original_State": "TX",
    "lat": 32.7762719,
    "lon": -96.7968559
  },
  {
    "original_Store Name": "Green Grass Mercantile",
    "original_City": "Weston",
    "original_State": "MO",
    "lat": 39.4143273,
    "lon": -94.9006328
  },
  {
    "original_Store Name": "ZZIEE Ceramics",
    "original_City": "Yucca Valley",
    "original_State": "CA",
    "lat": 34.1236205,
    "lon": -116.4139839
  },
  {
    "original_Store Name": "Bradbury Valley Farms",
    "original_City": "Russellville",
    "original_State": "AR",
    "lat": 35.2784173,
    "lon": -93.1337856
  },
  {
    "original_Store Name": "domecíl",
    "original_City": "Santa Barbara",
    "original_State": "CA",
    "lat": 34.4221319,
    "lon": -119.702667
  },
  {
    "original_Store Name": "La Maree Art",
    "original_City": "Portland",
    "original_State": "ME",
    "lat": 43.6573605,
    "lon": -70.2586618
  },
  {
    "original_Store Name": "The Kinlands",
    "original_City": "Riverton",
    "original_State": "UT",
    "lat": 40.5179761,
    "lon": -111.9393701
  },
  {
    "original_Store Name": "Weekend kitchen",
    "original_City": "Essex",
    "original_State": "CT",
    "lat": 41.3323144062144,
    "lon": -72.3951942593702
  },
  {
    "original_Store Name": "Red Acre Farm",
    "original_City": "Cedar City",
    "original_State": "UT",
    "lat": 37.6774238,
    "lon": -113.061827
  },
  {
    "original_Store Name": "Westhouse",
    "original_City": "Joint Base Lewis-McChord",
    "original_State": "WA",
    "lat": 47.131547,
    "lon": -122.484981
  },
  {
    "original_Store Name": "Koehn Sculptors & Designers Ltd",
    "original_City": "South Euclid",
    "original_State": "OH",
    "lat": 41.5231076,
    "lon": -81.5184553
  },
  {
    "original_Store Name": "Rosebud Home Goods",
    "original_City": "Eureka",
    "original_State": "CA",
    "lat": 40.8018746,
    "lon": -124.1707558
  },
  {
    "original_Store Name": "Woodhouse Day Spa",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Sfingiday",
    "original_City": "Seattle",
    "original_State": "WA",
    "lat": 47.6038321,
    "lon": -122.330062
  },
  {
    "original_Store Name": "Mt. Hope Farms",
    "original_City": "MOLALLA",
    "original_State": "OR",
    "lat": 45.1473445,
    "lon": -122.577032
  },
  {
    "original_Store Name": "captain oko",
    "original_City": "Point Reyes Station",
    "original_State": "CA",
    "lat": 38.0690895,
    "lon": -122.8069356
  },
  {
    "original_Store Name": "K•ROSE",
    "original_City": "Winfield",
    "original_State": "AL",
    "lat": 33.9281866,
    "lon": -87.8163017
  },
  {
    "original_Store Name": "7th Street Salvage",
    "original_City": "Macon",
    "original_State": "GA",
    "lat": 32.8406946,
    "lon": -83.6324022
  },
  {
    "original_Store Name": "Lady Farmer",
    "original_City": "Washington",
    "original_State": "DC",
    "lat": 38.8950368,
    "lon": -77.0365427
  },
  {
    "original_Store Name": "All Good Things/All Good Dogs",
    "original_City": "Historic New Castle",
    "original_State": "DE",
    "lat": 39.6609061,
    "lon": -75.5638578851119
  },
  {
    "original_Store Name": "Centre Square Cheese",
    "original_City": "Easton",
    "original_State": "PA",
    "lat": 40.6916081,
    "lon": -75.2099866
  },
  {
    "original_Store Name": "Petroglyphe Gallery",
    "original_City": "Mokelumne Hill",
    "original_State": "CA",
    "lat": 38.3004709,
    "lon": -120.706321
  },
  {
    "original_Store Name": "Gert's Snacks & Spices",
    "original_City": "Highlands",
    "original_State": "NJ",
    "lat": 40.40372,
    "lon": -73.991527
  },
  {
    "original_Store Name": "The Ole Post Office",
    "original_City": "Springville",
    "original_State": "AL",
    "lat": 33.7750997,
    "lon": -86.4716512
  },
  {
    "original_Store Name": "Re-Evolucion",
    "original_City": "Seattle",
    "original_State": "WA",
    "lat": 47.6038321,
    "lon": -122.330062
  },
  {
    "original_Store Name": "FrenchGardenHouse",
    "original_City": "Huntington Beach",
    "original_State": "CA",
    "lat": 33.6783336,
    "lon": -118.000016
  },
  {
    "original_Store Name": "Pewabic Pottery",
    "original_City": "Detroit",
    "original_State": "MI",
    "lat": 42.3315509,
    "lon": -83.0466403
  },
  {
    "original_Store Name": "Inscape",
    "original_City": "Sisters",
    "original_State": "OR",
    "lat": 44.290948,
    "lon": -121.549251
  },
  {
    "original_Store Name": "For The Love Of Spice",
    "original_City": "Gig Harbor",
    "original_State": "WA",
    "lat": 47.3259697,
    "lon": -122.5878659
  },
  {
    "original_Store Name": "Rust & Stardust",
    "original_City": "Rhinelander",
    "original_State": "WI",
    "lat": 45.636623,
    "lon": -89.412075
  },
  {
    "original_Store Name": "Bad Donkey Studio",
    "original_City": "Jasper",
    "original_State": "GA",
    "lat": 34.4678687,
    "lon": -84.4290918
  },
  {
    "original_Store Name": "Mallow Market",
    "original_City": "Rocklin",
    "original_State": "CA",
    "lat": 38.7907339,
    "lon": -121.2357828
  },
  {
    "original_Store Name": "Single Barrel Liquor and Bar",
    "original_City": "Bozeman",
    "original_State": "MT",
    "lat": 45.6794293,
    "lon": -111.044047
  },
  {
    "original_Store Name": "Liberty Vintage Marketplace",
    "original_City": "Covington",
    "original_State": "TN",
    "lat": 35.5642474,
    "lon": -89.6464672
  },
  {
    "original_Store Name": "Surfas Culinary District",
    "original_City": "Hot Springs",
    "original_State": "AR",
    "lat": 34.5038393,
    "lon": -93.0552437
  },
  {
    "original_Store Name": "Bold Fork Books",
    "original_City": "Washington DC",
    "original_State": "DC",
    "lat": 38.8950368,
    "lon": -77.0365427
  },
  {
    "original_Store Name": "Aragosta at Goose Cove Gift Shop",
    "original_City": "DEER ISLE",
    "original_State": "ME",
    "lat": 44.224044,
    "lon": -68.677597
  },
  {
    "original_Store Name": "Town Duck",
    "original_City": "Center",
    "original_State": "VA",
    "lat": 38.066393,
    "lon": -87.534888
  },
  {
    "original_Store Name": "The Maison French",
    "original_City": "Stockton",
    "original_State": "CA",
    "lat": 37.9577016,
    "lon": -121.290779
  },
  {
    "original_Store Name": "Mercantile at GrayBarns",
    "original_City": "Norwalk",
    "original_State": "CT",
    "lat": 41.1175966,
    "lon": -73.4078968
  },
  {
    "original_Store Name": "Early Bird Espresso + Mercantile",
    "original_City": "Frenchtown",
    "original_State": "NJ",
    "lat": 40.5264167,
    "lon": -75.0616084
  },
  {
    "original_Store Name": "Reva's Outrageous Cookies",
    "original_City": "Weston",
    "original_State": "CT",
    "lat": 41.2021302,
    "lon": -73.3812743
  },
  {
    "original_Store Name": "Willow by B Designs",
    "original_City": "Windham",
    "original_State": "NH",
    "lat": 42.8006441,
    "lon": -71.304229
  },
  {
    "original_Store Name": "Pawley Studios",
    "original_City": "Russellville",
    "original_State": "KY",
    "lat": 36.8453199,
    "lon": -86.887219
  },
  {
    "original_Store Name": "Blue Eden Farm",
    "original_City": "Mechanicsville",
    "original_State": "VA",
    "lat": 37.6039694,
    "lon": -77.3717321
  },
  {
    "original_Store Name": "The Inn and Trail Gourmet",
    "original_City": "Glen Arbor",
    "original_State": "MI",
    "lat": 44.8977316,
    "lon": -85.9888783
  },
  {
    "original_Store Name": "All Things Home",
    "original_City": "Weddington",
    "original_State": "NC",
    "lat": 35.0223708,
    "lon": -80.7609035
  },
  {
    "original_Store Name": "The Cottage Shop LLC",
    "original_City": "Portland",
    "original_State": "IN",
    "lat": 40.4344895,
    "lon": -84.9777455
  },
  {
    "original_Store Name": "Pinetop Olive Oil of Arizona LLC",
    "original_City": "Pinetop-Lakeside",
    "original_State": "AZ",
    "lat": 34.1448702,
    "lon": -109.9584743
  },
  {
    "original_Store Name": "West Coast Provisions",
    "original_City": "BEND",
    "original_State": "OR",
    "lat": 44.0581728,
    "lon": -121.3153096
  },
  {
    "original_Store Name": "Necessities Mercantile",
    "original_City": "Eldon",
    "original_State": "IA",
    "lat": 40.918054,
    "lon": -92.221951
  },
  {
    "original_Store Name": "Dandy Home & Ranch",
    "original_City": "Yuma",
    "original_State": "AZ",
    "lat": 32.7253096,
    "lon": -114.6188787
  },
  {
    "original_Store Name": "TN Museum Store",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Someone's In The Kitchen",
    "original_City": "Rapid City",
    "original_State": "SD",
    "lat": 44.0806041,
    "lon": -103.228023
  },
  {
    "original_Store Name": "Hudson River Kitchen",
    "original_City": "White Plains",
    "original_State": "NY",
    "lat": 41.0339862,
    "lon": -73.7629097
  },
  {
    "original_Store Name": "The Simple Nest",
    "original_City": "Salt Lake City",
    "original_State": "UT",
    "lat": 40.7596198,
    "lon": -111.886797
  },
  {
    "original_Store Name": "Tucker Hill Home",
    "original_City": "Fairfax",
    "original_State": "VA",
    "lat": 38.8462236,
    "lon": -77.3063733
  },
  {
    "original_Store Name": "Green Meadows Florist",
    "original_City": "Chadds Ford",
    "original_State": "PA",
    "lat": 39.872027,
    "lon": -75.5914213
  },
  {
    "original_Store Name": "Jasmin Reese Interiors",
    "original_City": "Chicago",
    "original_State": "IL",
    "lat": 41.8755616,
    "lon": -87.6244212
  },
  {
    "original_Store Name": "Termeh Gallery",
    "original_City": "Woodstock",
    "original_State": "GA",
    "lat": 34.1014112,
    "lon": -84.5192192
  },
  {
    "original_Store Name": "Uncommon Feasts",
    "original_City": "Lynn",
    "original_State": "MA",
    "lat": 42.466763,
    "lon": -70.9494939
  },
  {
    "original_Store Name": "Collective Market",
    "original_City": "Hillsboro",
    "original_State": "OR",
    "lat": 45.5228939,
    "lon": -122.989827
  },
  {
    "original_Store Name": "PALM Health",
    "original_City": "Clayton Township",
    "original_State": "MO",
    "lat": 38.641016,
    "lon": -90.367034
  },
  {
    "original_Store Name": "The Back Porch & company",
    "original_City": "Redmond ",
    "original_State": "OR",
    "lat": 44.2726203,
    "lon": -121.173921
  },
  {
    "original_Store Name": "#BooCrew",
    "original_City": "Oklahoma City",
    "original_State": "OK",
    "lat": 35.4729886,
    "lon": -97.5170536
  },
  {
    "original_Store Name": "Art Beat",
    "original_City": "NASHVILLE",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Hoffman Essentials",
    "original_City": "Wagoner",
    "original_State": "OK",
    "lat": 35.9593531,
    "lon": -95.3756535
  },
  {
    "original_Store Name": "Draper Mercantile & Trading Co LLC",
    "original_City": "Draper",
    "original_State": "VA",
    "lat": 37.0059537,
    "lon": -80.7472915
  },
  {
    "original_Store Name": "Moon + Arrow",
    "original_City": "Philadelphia",
    "original_State": "PA",
    "lat": 39.9527237,
    "lon": -75.1635262
  },
  {
    "original_Store Name": "Torte Jeff Pie Co",
    "original_City": "Brookhaven",
    "original_State": "NY",
    "lat": 40.7792653,
    "lon": -72.9153827
  },
  {
    "original_Store Name": "Embroider This",
    "original_City": "Stevensville",
    "original_State": "MD",
    "lat": 38.9807996,
    "lon": -76.3149908
  },
  {
    "original_Store Name": "Bluebonnet Bayou",
    "original_City": "Llano",
    "original_State": "TX",
    "lat": 30.752919,
    "lon": -98.6754992
  },
  {
    "original_Store Name": "Cultivate Market",
    "original_City": "Holladay",
    "original_State": "UT",
    "lat": 40.6710765,
    "lon": -111.8250278
  },
  {
    "original_Store Name": "Lavender Restyle Market",
    "original_City": "Southern Pines",
    "original_State": "NC",
    "lat": 35.1740471,
    "lon": -79.3922539
  },
  {
    "original_Store Name": "Lewes Gift Box Co.",
    "original_City": "Lewes",
    "original_State": "DE",
    "lat": 38.7733961,
    "lon": -75.1379574
  },
  {
    "original_Store Name": "The Grocer's Table",
    "original_City": "Wayzata",
    "original_State": "MN",
    "lat": 44.970759,
    "lon": -93.511947
  },
  {
    "original_Store Name": "The Prairie Thistle",
    "original_City": "Wickenburg",
    "original_State": "AZ",
    "lat": 33.9680962,
    "lon": -112.730135
  },
  {
    "original_Store Name": "London+Wood",
    "original_City": "Kentfield",
    "original_State": "CA",
    "lat": 37.9519958,
    "lon": -122.5572116
  },
  {
    "original_Store Name": "Little House Simple Living",
    "original_City": "Eustis",
    "original_State": "FL",
    "lat": 28.8527675,
    "lon": -81.6853534
  },
  {
    "original_Store Name": "Urban Girl Accessories",
    "original_City": "San Diego",
    "original_State": "CA",
    "lat": 32.7174202,
    "lon": -117.162772
  },
  {
    "original_Store Name": "Storied LLC",
    "original_City": "Seattle",
    "original_State": "WA",
    "lat": 47.6038321,
    "lon": -122.330062
  },
  {
    "original_Store Name": "Lucky Rubber Ducky",
    "original_City": "BROOKLYN",
    "original_State": "NY",
    "lat": 40.6526006,
    "lon": -73.9497211
  },
  {
    "original_Store Name": "Code Blue New York",
    "original_City": "Greenvale",
    "original_State": "NY",
    "lat": 40.8106558,
    "lon": -73.6284614
  },
  {
    "original_Store Name": "Southern Kitchen and Home",
    "original_City": "Huntsville",
    "original_State": "AL",
    "lat": 34.729847,
    "lon": -86.5859011
  },
  {
    "original_Store Name": "Gifts Matter",
    "original_City": "Lubbock",
    "original_State": "TX",
    "lat": 33.5855677,
    "lon": -101.8470215
  },
  {
    "original_Store Name": "111 Beef Republic",
    "original_City": "Bridgeport",
    "original_State": "TX",
    "lat": 33.2101155,
    "lon": -97.7547552
  },
  {
    "original_Store Name": "Good Morning Supply Company",
    "original_City": "Nevada City ",
    "original_State": "CA",
    "lat": 39.2625993,
    "lon": -121.0187304
  },
  {
    "original_Store Name": "Das Bevo",
    "original_City": "Saint Louis",
    "original_State": "MO",
    "lat": 38.6280278,
    "lon": -90.1910154
  },
  {
    "original_Store Name": "Heaven Sent Children's Boutique",
    "original_City": "Lewisville",
    "original_State": "TX",
    "lat": 33.046233,
    "lon": -96.994174
  },
  {
    "original_Store Name": "The Ancestral Homekeeper Shop",
    "original_City": "Novato",
    "original_State": "CA",
    "lat": 38.1061979,
    "lon": -122.5681191
  },
  {
    "original_Store Name": "Tosca",
    "original_City": "Missoula",
    "original_State": "MT",
    "lat": 46.8701049,
    "lon": -113.995267
  },
  {
    "original_Store Name": "Mandara SPA",
    "original_City": "Fort Collins",
    "original_State": "CO",
    "lat": 40.5871782,
    "lon": -105.0770113
  },
  {
    "original_Store Name": "Belle Box Co",
    "original_City": "Waltham",
    "original_State": "MA",
    "lat": 42.3762385,
    "lon": -71.2355644
  },
  {
    "original_Store Name": "Wild Bees Bottle Shop",
    "original_City": "Chester",
    "original_State": "SC",
    "lat": 34.7048613,
    "lon": -81.2142561
  },
  {
    "original_Store Name": "The Local Bevy",
    "original_City": "Springfield",
    "original_State": "MO",
    "lat": 37.2081729,
    "lon": -93.2922715
  },
  {
    "original_Store Name": "Wisp Botanicals (DBA Wisp)",
    "original_City": "Lunenburg",
    "original_State": "NS",
    "lat": 44.3774954,
    "lon": -64.3154816
  },
  {
    "original_Store Name": "Lagom",
    "original_City": "brockport",
    "original_State": "NY",
    "lat": 43.213671,
    "lon": -77.93918
  },
  {
    "original_Store Name": "The Windfall",
    "original_City": "Lansing",
    "original_State": "NC",
    "lat": 36.4993936,
    "lon": -81.5109852
  },
  {
    "original_Store Name": "The Cottage Goddess DBA My Tipsy Gypsy",
    "original_City": "BELLEVILLE",
    "original_State": "WI",
    "lat": 42.8596864,
    "lon": -89.5346023
  },
  {
    "original_Store Name": "Marché",
    "original_City": "San Francisco",
    "original_State": "CA",
    "lat": 37.7792588,
    "lon": -122.4193286
  },
  {
    "original_Store Name": "POTLUCK KItchenware",
    "original_City": "Ely",
    "original_State": "MN",
    "lat": 47.901571,
    "lon": -91.8572479
  },
  {
    "original_Store Name": "The winsome nests",
    "original_City": "Walnut Grove",
    "original_State": "CA",
    "lat": 38.2432643,
    "lon": -121.512046
  },
  {
    "original_Store Name": "Gallery On the Square",
    "original_City": "Franklin",
    "original_State": "KY",
    "lat": 36.722263,
    "lon": -86.5772177
  },
  {
    "original_Store Name": "Mavens and Makers",
    "original_City": "Baileyton",
    "original_State": "AL",
    "lat": 34.2623179,
    "lon": -86.6127712
  },
  {
    "original_Store Name": "Modern Supply",
    "original_City": "Royal Oak",
    "original_State": "MI",
    "lat": 42.4894801,
    "lon": -83.1446485
  },
  {
    "original_Store Name": "The Lone Hare",
    "original_City": "Owens Cross Roads",
    "original_State": "AL",
    "lat": 34.5881461,
    "lon": -86.4588768
  },
  {
    "original_Store Name": "Kaki Company",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Miss Jay's Market",
    "original_City": "Pearson",
    "original_State": "GA",
    "lat": 31.297703,
    "lon": -82.8523668
  },
  {
    "original_Store Name": "The Chandlerie",
    "original_City": "CHRISTIANSBURG",
    "original_State": "VA",
    "lat": 37.1298517,
    "lon": -80.4089389
  },
  {
    "original_Store Name": "CDA Innovations, LLC",
    "original_City": "Charlotte",
    "original_State": "NC",
    "lat": 35.2272086,
    "lon": -80.8430827
  },
  {
    "original_Store Name": "Good Things Grocery",
    "original_City": "Lockhart",
    "original_State": "TX",
    "lat": 44.050447,
    "lon": -122.999004
  },
  {
    "original_Store Name": "Friends of Arrow Rock",
    "original_City": "Arrow Rock",
    "original_State": "MO",
    "lat": 39.10449115,
    "lon": -94.3774514341859
  },
  {
    "original_Store Name": "Blanco Creek Boutique",
    "original_City": "Tucumcari",
    "original_State": "NM",
    "lat": 35.1719425,
    "lon": -103.72504
  },
  {
    "original_Store Name": "Bleu on Bank",
    "original_City": "New Milford",
    "original_State": "CT",
    "lat": 41.5770993,
    "lon": -73.4105803
  },
  {
    "original_Store Name": "Cabinetlab",
    "original_City": "Toronto",
    "original_State": "ON",
    "lat": 43.6534817,
    "lon": -79.3839347
  },
  {
    "original_Store Name": "Gathering Board Co., LLC",
    "original_City": "Hewitt",
    "original_State": "TX",
    "lat": 31.4623065,
    "lon": -97.1957023
  },
  {
    "original_Store Name": "Village Drug Co.",
    "original_City": "Birmingham",
    "original_State": "AL",
    "lat": 33.5206824,
    "lon": -86.8024326
  },
  {
    "original_Store Name": "Hair Razors",
    "original_City": "Catskill",
    "original_State": "NY",
    "lat": 42.2173102,
    "lon": -73.8645734
  },
  {
    "original_Store Name": "Teak & Twine",
    "original_City": "Springfield",
    "original_State": "VA",
    "lat": 38.7791227,
    "lon": -77.1861196
  },
  {
    "original_Store Name": "Gathered",
    "original_City": "Charlotte",
    "original_State": "NC",
    "lat": 35.2272086,
    "lon": -80.8430827
  },
  {
    "original_Store Name": "Suite Dreams",
    "original_City": "Birmingham",
    "original_State": "AL",
    "lat": 33.5206824,
    "lon": -86.8024326
  },
  {
    "original_Store Name": "Noble Goat Farm Stand",
    "original_City": "Healdsburg",
    "original_State": "CA",
    "lat": 38.6106812,
    "lon": -122.870138
  },
  {
    "original_Store Name": "Iris",
    "original_City": "West Orange",
    "original_State": "NJ",
    "lat": 40.7987113,
    "lon": -74.2390353
  },
  {
    "original_Store Name": "Harvest Local Foods",
    "original_City": "Manchester",
    "original_State": "TN",
    "lat": 35.4832001,
    "lon": -86.0887296
  },
  {
    "original_Store Name": "Sue Spargo",
    "original_City": "Uniontown",
    "original_State": "OH",
    "lat": 40.1306251,
    "lon": -80.9917631
  },
  {
    "original_Store Name": "Olivia & Daisy",
    "original_City": "Carmel Valley",
    "original_State": "CA",
    "lat": 32.9434337,
    "lon": -117.2139794
  },
  {
    "original_Store Name": "Rhea's Mill",
    "original_City": "Lincoln",
    "original_State": "AR",
    "lat": 35.9494569,
    "lon": -94.4233612
  },
  {
    "original_Store Name": "Humble Valley Homestead",
    "original_City": "DeQueen",
    "original_State": "AR",
    "lat": 37.510038,
    "lon": -86.806892
  },
  {
    "original_Store Name": "Creekside Gift Designs",
    "original_City": "Tomball",
    "original_State": "TX",
    "lat": 30.0971621,
    "lon": -95.6160549
  },
  {
    "original_Store Name": "Billie’s Grocery",
    "original_City": "Leawood",
    "original_State": "KS",
    "lat": 38.966673,
    "lon": -94.6169012
  },
  {
    "original_Store Name": "Shabby Apple Creations, LLC",
    "original_City": "El Paso",
    "original_State": "TX",
    "lat": 31.7601164,
    "lon": -106.4870404
  },
  {
    "original_Store Name": "Baack's Flowers & More",
    "original_City": "Abilene",
    "original_State": "TX",
    "lat": 32.44645,
    "lon": -99.7475905
  },
  {
    "original_Store Name": "The Old Store at Grassy Creek",
    "original_City": "Grassy Creek",
    "original_State": "NC",
    "lat": 35.8823454,
    "lon": -82.056782
  },
  {
    "original_Store Name": "Wilma & Rose",
    "original_City": "Bellevue",
    "original_State": "NE",
    "lat": 41.1365122,
    "lon": -95.8937398
  },
  {
    "original_Store Name": "The Squirrel and Nut LLC",
    "original_City": "Lansing",
    "original_State": "NC",
    "lat": 36.4993936,
    "lon": -81.5109852
  },
  {
    "original_Store Name": "Tin Top Art & Handmade",
    "original_City": "Winchester",
    "original_State": "VA",
    "lat": 39.1852184,
    "lon": -78.1652404
  },
  {
    "original_Store Name": "HOUSE15143",
    "original_City": "Sewickley",
    "original_State": "PA",
    "lat": 40.5403417,
    "lon": -80.1805269
  },
  {
    "original_Store Name": "Apryl Doster",
    "original_City": "Mobile",
    "original_State": "AL",
    "lat": 30.6913462,
    "lon": -88.0437509
  },
  {
    "original_Store Name": "A. Gardner Design, LLC",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Stone Hollow Farmstead",
    "original_City": "Harpersville",
    "original_State": "AL",
    "lat": 33.3439995,
    "lon": -86.4380357
  },
  {
    "original_Store Name": "Fearless Cooking",
    "original_City": "Chicago",
    "original_State": "IL",
    "lat": 41.8755616,
    "lon": -87.6244212
  },
  {
    "original_Store Name": "Oklahoma History Center",
    "original_City": "Oklahoma City",
    "original_State": "OK",
    "lat": 35.4729886,
    "lon": -97.5170536
  },
  {
    "original_Store Name": "Plume & Willow dba of ohhhhmyGoodness",
    "original_City": "Mint Hill",
    "original_State": "NC",
    "lat": 35.1735388,
    "lon": -80.6570377
  },
  {
    "original_Store Name": "Tanya Hargat Art & Designs",
    "original_City": "Plymouth",
    "original_State": "MA",
    "lat": 41.9583799,
    "lon": -70.6673851
  },
  {
    "original_Store Name": "SlowSimpleSeasonal",
    "original_City": "Palos Heights",
    "original_State": "IL",
    "lat": 41.6681632,
    "lon": -87.7962812
  },
  {
    "original_Store Name": "Little Nelly",
    "original_City": "Burbank",
    "original_State": "CA",
    "lat": 37.248998,
    "lon": -121.92327
  },
  {
    "original_Store Name": "Farmers Storehouse",
    "original_City": "Sparta",
    "original_State": "TN",
    "lat": 35.9258921,
    "lon": -85.4641342
  },
  {
    "original_Store Name": "Dozen Bakery",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "More On Main",
    "original_City": "Streator",
    "original_State": "IL",
    "lat": 40.117064,
    "lon": -88.240523
  },
  {
    "original_Store Name": "The JAS Corner Store",
    "original_City": "Seattle",
    "original_State": "WA",
    "lat": 47.6038321,
    "lon": -122.330062
  },
  {
    "original_Store Name": "Here I Am box",
    "original_City": "Long Beach",
    "original_State": "CA",
    "lat": 33.7690164,
    "lon": -118.191604
  },
  {
    "original_Store Name": "Sweet Mabel Art & Fine Craft",
    "original_City": "Narberth",
    "original_State": "PA",
    "lat": 40.0084456,
    "lon": -75.26046
  },
  {
    "original_Store Name": "Winsome Details",
    "original_City": "Whispering Pines",
    "original_State": "NC",
    "lat": 35.2557123,
    "lon": -79.3722503
  },
  {
    "original_Store Name": "Just Jan's",
    "original_City": "Woodland Hills",
    "original_State": "CA",
    "lat": 34.1684364,
    "lon": -118.6058382
  },
  {
    "original_Store Name": "Stillhouse Herbals Botanical Boutique",
    "original_City": "Mt. Juliet",
    "original_State": "TN",
    "lat": 36.200055,
    "lon": -86.5186054
  },
  {
    "original_Store Name": "Skye clothing boutique",
    "original_City": "Auburn",
    "original_State": "CA",
    "lat": 38.8945939,
    "lon": -121.0739897
  },
  {
    "original_Store Name": "Wellesley Books",
    "original_City": "Wellesley",
    "original_State": "MA",
    "lat": 42.2964859,
    "lon": -71.2925571
  },
  {
    "original_Store Name": "The Oil Tree",
    "original_City": "Oklahoma City",
    "original_State": "OK",
    "lat": 35.4729886,
    "lon": -97.5170536
  },
  {
    "original_Store Name": "Damm & Steuer",
    "original_City": "Oyster Bay",
    "original_State": "NY",
    "lat": 40.8736879,
    "lon": -73.5323172
  },
  {
    "original_Store Name": "Bank of Flowers",
    "original_City": "Pewaukee",
    "original_State": "WI",
    "lat": 43.0805651,
    "lon": -88.2612045
  },
  {
    "original_Store Name": "Simple Goodness Soda Shop",
    "original_City": "Wilkeson",
    "original_State": "WA",
    "lat": 47.1053802,
    "lon": -122.045667
  },
  {
    "original_Store Name": "The Forge at Skull Valley",
    "original_City": "Skull Valley",
    "original_State": "AZ",
    "lat": 34.5053024,
    "lon": -112.6854541
  },
  {
    "original_Store Name": "Caswell Mercantile Co.",
    "original_City": "Yanceyville",
    "original_State": "NC",
    "lat": 36.4040273,
    "lon": -79.3361314
  },
  {
    "original_Store Name": "Found at Redbrick",
    "original_City": "Batley",
    "original_State": "",
    "lat": 53.716564,
    "lon": -1.6363856
  },
  {
    "original_Store Name": "Pier 303 Seafood Market",
    "original_City": "Enterprise",
    "original_State": "OR",
    "lat": 45.4258114,
    "lon": -117.278012
  },
  {
    "original_Store Name": "Elk River Carving Company",
    "original_City": "Fayetteville",
    "original_State": "TN",
    "lat": 35.1520267,
    "lon": -86.5705509
  },
  {
    "original_Store Name": "Seven Willows body care co.",
    "original_City": "Statesboro",
    "original_State": "GA",
    "lat": 32.4490141,
    "lon": -81.7832912
  },
  {
    "original_Store Name": "Braglio Farms",
    "original_City": "Randallstown",
    "original_State": "MD",
    "lat": 39.3676814,
    "lon": -76.7954689
  },
  {
    "original_Store Name": "Lucky Run Creations",
    "original_City": "Selkirk",
    "original_State": "NY",
    "lat": 42.5323027,
    "lon": -73.7984563
  },
  {
    "original_Store Name": "Vidalias",
    "original_City": "Gloucester",
    "original_State": "MA",
    "lat": 42.6153595,
    "lon": -70.6624608
  },
  {
    "original_Store Name": "Whisk and Sugar Bakery",
    "original_City": "Charlottetown",
    "original_State": "PE",
    "lat": 46.2354187,
    "lon": -63.1265388
  },
  {
    "original_Store Name": "hollingsworth showroom",
    "original_City": "Tampa",
    "original_State": "FL",
    "lat": 27.9477595,
    "lon": -82.458444
  },
  {
    "original_Store Name": "Janay’s Essential’s",
    "original_City": "Albion",
    "original_State": "ID",
    "lat": 42.4126885,
    "lon": -113.578063
  },
  {
    "original_Store Name": "Little H Mercantile, LLC",
    "original_City": "Monroe",
    "original_State": "NC",
    "lat": 34.9854275,
    "lon": -80.5495112
  },
  {
    "original_Store Name": "Salt Water Farm Shop",
    "original_City": "Camden ",
    "original_State": "ME",
    "lat": 44.210265,
    "lon": -69.065552
  },
  {
    "original_Store Name": "bellina gifts",
    "original_City": "Darnestown",
    "original_State": "MD",
    "lat": 39.10322,
    "lon": -77.2918103
  },
  {
    "original_Store Name": "Rexer Family Farm",
    "original_City": "Huntington",
    "original_State": "NY",
    "lat": 40.868154,
    "lon": -73.425676
  },
  {
    "original_Store Name": "Fiona Tree Home",
    "original_City": "Sherman oaks ",
    "original_State": "CA",
    "lat": 34.1508718,
    "lon": -118.448986
  },
  {
    "original_Store Name": "Equinox botanical boutique",
    "original_City": "Kenosha",
    "original_State": "WI",
    "lat": 42.5846773,
    "lon": -87.8212263
  },
  {
    "original_Store Name": "Southern Grace Manor, LLC",
    "original_City": "Keystone Heights",
    "original_State": "FL",
    "lat": 29.7860769,
    "lon": -82.0314892
  },
  {
    "original_Store Name": "Craft Farm",
    "original_City": "Corning",
    "original_State": "NY",
    "lat": 42.1435257,
    "lon": -77.0543408
  },
  {
    "original_Store Name": "Gilbert Girls LLC",
    "original_City": "Gilbert",
    "original_State": "AZ",
    "lat": 33.3527632,
    "lon": -111.789037
  },
  {
    "original_Store Name": "Essentially Classic",
    "original_City": "New Rochelle",
    "original_State": "NY",
    "lat": 40.9115386,
    "lon": -73.7826363
  },
  {
    "original_Store Name": "Queen of Threads Monogramming",
    "original_City": "Lake Charles",
    "original_State": "LA",
    "lat": 30.2305095,
    "lon": -93.2169807
  },
  {
    "original_Store Name": "A Curated Kitchen",
    "original_City": "East Amwell Township",
    "original_State": "NJ",
    "lat": 40.4432331,
    "lon": -74.814333
  },
  {
    "original_Store Name": "Peach Tree Home Decor and Renovation",
    "original_City": "Austin",
    "original_State": "TX",
    "lat": 30.2711286,
    "lon": -97.7436995
  },
  {
    "original_Store Name": "Just Simply Pickleball LLC",
    "original_City": "Van Buren",
    "original_State": "AR",
    "lat": 35.4424419,
    "lon": -94.3431393
  },
  {
    "original_Store Name": "STUBBEES",
    "original_City": "St. Augustine",
    "original_State": "FL",
    "lat": 29.8946952,
    "lon": -81.3145395
  },
  {
    "original_Store Name": "Rust & Rose LLC",
    "original_City": "Monticello",
    "original_State": "FL",
    "lat": 30.5452022,
    "lon": -83.8701636
  },
  {
    "original_Store Name": "Winchester Creek Farm Inc",
    "original_City": "Waynesville",
    "original_State": "NC",
    "lat": 35.4887476,
    "lon": -82.9888725
  },
  {
    "original_Store Name": "Divine Goods",
    "original_City": "Lookout Mountain",
    "original_State": "TN",
    "lat": 34.9942422,
    "lon": -85.3494027
  },
  {
    "original_Store Name": "August Table",
    "original_City": "White Stone",
    "original_State": "VA",
    "lat": 37.6484751,
    "lon": -76.3891188
  },
  {
    "original_Store Name": "Atkins farms country market 1150 West St. Amherst, Ma.",
    "original_City": "Amherst",
    "original_State": "MA",
    "lat": 42.3731948,
    "lon": -72.5198761
  },
  {
    "original_Store Name": "East Cove Treasures",
    "original_City": "Greenville",
    "original_State": "ME",
    "lat": 45.458955,
    "lon": -69.5916835
  },
  {
    "original_Store Name": "Curated Pop-Up",
    "original_City": "Denver",
    "original_State": "CO",
    "lat": 39.7392364,
    "lon": -104.984862
  },
  {
    "original_Store Name": "Gamboard company",
    "original_City": "Arlington Heights ",
    "original_State": "IL",
    "lat": 42.0811563,
    "lon": -87.9802164
  },
  {
    "original_Store Name": "Savannah Taste Experience Food Tours",
    "original_City": "Savannah",
    "original_State": "GA",
    "lat": 32.0790074,
    "lon": -81.0921335
  },
  {
    "original_Store Name": "True North Gallery",
    "original_City": "Hamilton",
    "original_State": "MA",
    "lat": 42.6362052,
    "lon": -70.8431049
  },
  {
    "original_Store Name": "Birch 303",
    "original_City": "Ashland",
    "original_State": "WI",
    "lat": 46.5924023,
    "lon": -90.8839474
  },
  {
    "original_Store Name": "Edgecomb Potters",
    "original_City": "Edgecomb",
    "original_State": "ME",
    "lat": 43.9586733,
    "lon": -69.6304341
  },
  {
    "original_Store Name": "Seasons Home Design",
    "original_City": "Dublin",
    "original_State": "OH",
    "lat": 40.0996009,
    "lon": -83.1135563
  },
  {
    "original_Store Name": "Coast Collective",
    "original_City": "Hinsdale",
    "original_State": "IL",
    "lat": 41.8024604,
    "lon": -87.9299841
  },
  {
    "original_Store Name": "Botanik",
    "original_City": "Summerland",
    "original_State": "CA",
    "lat": 34.4213845,
    "lon": -119.5965173
  },
  {
    "original_Store Name": "Country Roots Design",
    "original_City": "Oregon",
    "original_State": "MO",
    "lat": 39.9869407,
    "lon": -95.1449753
  },
  {
    "original_Store Name": "hart + honey",
    "original_City": "Carlsbad",
    "original_State": "CA",
    "lat": 33.1580933,
    "lon": -117.3505966
  },
  {
    "original_Store Name": "Naturally Curated",
    "original_City": "Alpharetta",
    "original_State": "GA",
    "lat": 34.0755962,
    "lon": -84.2945964
  },
  {
    "original_Store Name": "Dietz Distillery",
    "original_City": "Fredericksburg",
    "original_State": "TX",
    "lat": 30.2752011,
    "lon": -98.8719843
  },
  {
    "original_Store Name": "All lathered up",
    "original_City": "Carthage",
    "original_State": "MO",
    "lat": 37.1765141,
    "lon": -94.3103412
  },
  {
    "original_Store Name": "GEORGE-MARY'S",
    "original_City": "Starkville",
    "original_State": "MS",
    "lat": 33.4638745,
    "lon": -88.8152074
  },
  {
    "original_Store Name": "Buffalo Niagara Heritage Village",
    "original_City": "Amherst",
    "original_State": "NY",
    "lat": 42.9783924,
    "lon": -78.7997616
  },
  {
    "original_Store Name": "Found & Flora",
    "original_City": "Wahoo",
    "original_State": "NE",
    "lat": 41.2111084,
    "lon": -96.6197985
  },
  {
    "original_Store Name": "Hyla f",
    "original_City": "Los Angeles",
    "original_State": "CA",
    "lat": 34.0536909,
    "lon": -118.242766
  },
  {
    "original_Store Name": "Jugtown Pottery",
    "original_City": "Seagrove",
    "original_State": "NC",
    "lat": 35.5408425,
    "lon": -79.7778859
  },
  {
    "original_Store Name": "Well Found Home",
    "original_City": "Beaverton",
    "original_State": "OR",
    "lat": 45.4871723,
    "lon": -122.80378
  },
  {
    "original_Store Name": "Madison Modern Market",
    "original_City": "Madison",
    "original_State": "WI",
    "lat": 43.07469,
    "lon": -89.3841663
  },
  {
    "original_Store Name": "Marigold Market",
    "original_City": "Ottawa",
    "original_State": "ON",
    "lat": 45.4208777,
    "lon": -75.6901106
  },
  {
    "original_Store Name": "Marne Creek Mercantile",
    "original_City": "Yankton",
    "original_State": "SD",
    "lat": 42.8712938,
    "lon": -97.3967011
  },
  {
    "original_Store Name": "Midnight Kin",
    "original_City": "Placerville",
    "original_State": "CA",
    "lat": 38.7296252,
    "lon": -120.798546
  },
  {
    "original_Store Name": "Mel Boteri / MB Fashion Partners",
    "original_City": "Roswell",
    "original_State": "GA",
    "lat": 34.02332,
    "lon": -84.360022
  },
  {
    "original_Store Name": "modtique",
    "original_City": "Delafield",
    "original_State": "WI",
    "lat": 43.0594237,
    "lon": -88.4040172
  },
  {
    "original_Store Name": "Studio Amana",
    "original_City": "Brampton",
    "original_State": "ON",
    "lat": 43.685832,
    "lon": -79.7599366
  },
  {
    "original_Store Name": "Pour Choices",
    "original_City": "Charles Town",
    "original_State": "WV",
    "lat": 39.2891836,
    "lon": -77.859581
  },
  {
    "original_Store Name": " SEMLER FARMS ",
    "original_City": "Franklin",
    "original_State": "TN",
    "lat": 35.925206,
    "lon": -86.8689419
  },
  {
    "original_Store Name": "Well Seasoned Table",
    "original_City": "Candler",
    "original_State": "NC",
    "lat": 35.5444359,
    "lon": -82.6838032
  },
  {
    "original_Store Name": "Klever Kitchen",
    "original_City": "Wray",
    "original_State": "GA",
    "lat": 31.6224128,
    "lon": -83.0548714
  },
  {
    "original_Store Name": "Two Flamingos Gift Shop",
    "original_City": "Starkville",
    "original_State": "MS",
    "lat": 33.4638745,
    "lon": -88.8152074
  },
  {
    "original_Store Name": "FITLAB Strong",
    "original_City": "Fairfax",
    "original_State": "CA",
    "lat": 37.9872935,
    "lon": -122.587967
  },
  {
    "original_Store Name": "Berry + Basil",
    "original_City": "Chamberlain",
    "original_State": "SD",
    "lat": 43.810817,
    "lon": -99.330178
  },
  {
    "original_Store Name": "StudioFlora",
    "original_City": "Easttown Township",
    "original_State": "PA",
    "lat": 40.02773585,
    "lon": -75.4386165109114
  },
  {
    "original_Store Name": "Eureka Casino Resort",
    "original_City": "Mesquite",
    "original_State": "NV",
    "lat": 36.8035642,
    "lon": -114.067141
  },
  {
    "original_Store Name": "Karger Gallery",
    "original_City": "Centre Wellington",
    "original_State": "ON",
    "lat": 43.71809265,
    "lon": -80.3747735563671
  },
  {
    "original_Store Name": "Moon Over Water Gallery and Artisan Market",
    "original_City": "Hillsboro",
    "original_State": "TX",
    "lat": 32.0108506,
    "lon": -97.1303744
  },
  {
    "original_Store Name": "Provisions on Main",
    "original_City": "Duluth",
    "original_State": "GA",
    "lat": 34.0028569,
    "lon": -84.1441046
  },
  {
    "original_Store Name": "Historic Westville",
    "original_City": "Columbus",
    "original_State": "GA",
    "lat": 32.4610708,
    "lon": -84.9880449
  },
  {
    "original_Store Name": "The Bottle Shop at McEwen",
    "original_City": "Franklin",
    "original_State": "TN",
    "lat": 35.925206,
    "lon": -86.8689419
  },
  {
    "original_Store Name": "GATHER & MILL",
    "original_City": "GRASS VALLEY",
    "original_State": "CA",
    "lat": 39.2190607,
    "lon": -121.06292
  },
  {
    "original_Store Name": "SB Trading Co",
    "original_City": "Martinez",
    "original_State": "CA",
    "lat": 38.0138934,
    "lon": -122.1338674
  },
  {
    "original_Store Name": "American Journeyman",
    "original_City": "Martinez",
    "original_State": "GA",
    "lat": 33.5173577,
    "lon": -82.0756734
  },
  {
    "original_Store Name": "Virginia Mercantile",
    "original_City": "Fairfax Station",
    "original_State": "VA",
    "lat": 38.800859,
    "lon": -77.3256803
  },
  {
    "original_Store Name": "Euna Mae's",
    "original_City": "Charleston",
    "original_State": "SC",
    "lat": 32.7884363,
    "lon": -79.9399309
  },
  {
    "original_Store Name": "Rocking W4 Apparel",
    "original_City": "Duncan",
    "original_State": "OK",
    "lat": 34.5023029,
    "lon": -97.9578129
  },
  {
    "original_Store Name": "Isadora Popper",
    "original_City": "Greenville",
    "original_State": "SC",
    "lat": 34.851354,
    "lon": -82.3984882
  },
  {
    "original_Store Name": "Grand Personal Chef",
    "original_City": "Chicago",
    "original_State": "IL",
    "lat": 41.8755616,
    "lon": -87.6244212
  },
  {
    "original_Store Name": "Muddy's Bake Shop",
    "original_City": "Memphis",
    "original_State": "TN",
    "lat": 35.1460249,
    "lon": -90.0517638
  },
  {
    "original_Store Name": "Tabletop",
    "original_City": "Takoma Park",
    "original_State": "MD",
    "lat": 38.9778882,
    "lon": -77.0074765
  },
  {
    "original_Store Name": "Marrs Mercantile",
    "original_City": "Centerton",
    "original_State": "AR",
    "lat": 36.3652679,
    "lon": -94.2886875
  },
  {
    "original_Store Name": "Viola's Market",
    "original_City": "Saint Simons Island",
    "original_State": "GA",
    "lat": 31.1508431,
    "lon": -81.3695974
  },
  {
    "original_Store Name": "Cheree Berry Paper & Design",
    "original_City": "St. Louis",
    "original_State": "MO",
    "lat": 38.6280278,
    "lon": -90.1910154
  },
  {
    "original_Store Name": "Oak Creek Furniture",
    "original_City": "Texarkana",
    "original_State": "TX",
    "lat": 33.44667445,
    "lon": -94.0771483052202
  },
  {
    "original_Store Name": "Laurel House",
    "original_City": "Nashville",
    "original_State": "TN",
    "lat": 36.1622767,
    "lon": -86.7742984
  },
  {
    "original_Store Name": "Ladles and Linens",
    "original_City": "Lexington",
    "original_State": "VA",
    "lat": 37.7848664,
    "lon": -79.4423367
  },
  {
    "original_Store Name": "Ladles and Linens",
    "original_City": "Roanoake",
    "original_State": "VA",
    "lat": 37.7848664,
    "lon": -79.4423367
  },
  {
    "original_Store Name": "Ladles and Linens",
    "original_City": "Richmond",
    "original_State": "VA",
    "lat": 37.7848664,
    "lon": -79.4423367
  },
  {
    "original_Store Name": "Little House Green Grocery",
    "original_City": "Richmond",
    "original_State": "VA",
    "lat": 37.5385087,
    "lon": -77.43428
  },
  {
    "original_Store Name": "Eco Chic Boutique",
    "original_City": "Fargo",
    "original_State": "ND",
    "lat": 46.877229,
    "lon": -96.789821
  },
  {
    "original_Store Name": "Ginger Thomas Soap Company.com",
    "original_City": "Oswego",
    "original_State": "IL",
    "lat": 30.883212,
    "lon": -83.941808
  },
  {
    "original_Store Name": "Euna Mae's",
    "original_City": "Springdale Township",
    "original_State": "AR",
    "lat": 34.67101,
    "lon": -82.986912
  },
  {
    "original_Store Name": "Pane In the Glass",
    "original_City": "St. Simons",
    "original_State": "GA",
    "lat": 31.1353801,
    "lon": -81.3895192
  },
  {
    "original_Store Name": "Fork of the South General Store",
    "original_City": "Franklin",
    "original_State": "TN",
    "lat": 35.925206,
    "lon": -86.8689419
  },
  {
    "original_Store Name": "The Find North",
    "original_City": "Leland",
    "original_State": "MI",
    "lat": 45.0228754,
    "lon": -85.7601164
  },
  {
    "original_Store Name": "Whisper Me Home",
    "original_City": "Lyons Township",
    "original_State": "IL",
    "lat": 41.7702216,
    "lon": -87.8584455900724
  }
];